export default {
  common: {
    confirm: "Bestätigen",
    back: "Zurück",
    plus: "PLUS",
    pro: "PRO",
  },
  today: "Heute",
  notFound: {
    title: "Oh nein! Fehler 404",
    text: "Ups! Diese Seite scheint einen Umweg genommen zu haben. Lassen Sie uns Ihnen helfen, zurück zu Ihrem Ziel zu finden.",
    button: "Zurück zur Startseite",
  },
  dateRangePicker: {
    title: "Zeitraum auswählen",
    startLabel: "Von",
    endLabel: "Bis",
  },
  expiresIn: {
    day: "1 Tag",
    days: "{{days}} Tagen",
    month: "1 Monat",
    months: "{{months}} Monaten",
  },
  copiedToClipboard: "In die Zwischenablage kopiert",
  bankImportStatus: {
    importedData: "Importierte Bankdaten",
    updatedData: "Aktualisierte Bankdaten",
    successImport: "Bankdaten erfolgreich importiert",
    successUpdate: "Bankdaten erfolgreich aktualisiert",
    errorImport: "Bankdaten-Import fehlgeschlagen",
    errorUpdate: "Bankdaten-Update fehlgeschlagen",
    status: {
      CONNECTING: "Stelle Verbindung zur Bank her",
      DECOUPLED_AUTH_REQUIRED:
        "Bitte bestätigen Sie den Banking-Login in Ihrer Banking-APP",
      VERIFYING_CHALLENGE_RESPONSE: "Prüfe TAN",
      AUTHENTICATION_IN_PROGRESS: "Führe Authentifizierung durch",
      AUTHENTICATION_FAILED: "Authentifizierung fehlgeschlagen",
      ACCOUNTS: "Rufe Konten ab",
      TRANSACTIONS: "Rufe Transaktionsdaten ab",
      SECURITIES: "Rufe Wertpapierdaten ab",
      PERSISTING_TRANSACTIONS: "Speichere Transaktionshistorie",
      PERSISTING_BOOKINGS: "Speichere Orderhistorie",
      SUCCESS: "Alle Daten gespeichert",
      FAILED_WITH_ERROR: "Unerwarteter Fehler",
    },
  },
  dropdownWithSections: {
    noOptions: "Keine Optionen verfügbar",
    noMatches: "Keine Übereinstimmungen gefunden",
    loading: "Lade...",
  },
  form: {
    yes: "ja",
    no: "nein",
    successMessage: "Ihre Daten wurden erfolgreich gespeichert",
    errors: {
      pdfImport:
        "Leider konnten wir eine oder mehrere Ihrer PDF-Dateien nicht auslesen, bitte versuchen Sie es erneut",
      pdfImportFileLength:
        "Sie haben mehr als 10 Dateien ausgewählt. Es können maximal 10 Dateien verarbeitet werden. Zusätzliche Dateien werden nicht akzeptiert",
      required: "Dieses Feld wird benötigt.",
      wrongEmailFormat: "Ungültiges Email Format.",
      emailsNotMatched: "Emails sollten übereinstimmen.",
      passwordMinLength: "Passwort sollte mindestens 8 Zeichen lang sein.",
      passwordsNotMatched: "Passwörter sollten übereinstimmen.",
      wrongDateFormat: "Ungültiges Datum Format.",
      wrongIbanFormat:
        "IBAN ist ungültig. Bitte überprüfen Sie dies und geben Sie eine gültige IBAN ein.",
      wrongPhoneFormat:
        "Ungültiges Telefon Format. Bitte verwenden Sie nur Ziffern und das + Symbol.",
      min: "Dieses Feld muss mindestens {{min}} Zeichen lang sein.",
      emailAlreadyExists: "Diese Email Adresse ist bereits registriert.",
      somethingWentWrong:
        "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
      noData: "Keine Daten verfügbar",
    },
  },
  domains: {
    dividends: {
      dividendsTable: {
        noDividends: "Keine Dividenden",
      },
    },
    cashback: {
      download: {
        customerFirstName: "Vorname",
        customerLastName: "Nachname",
        bank: "Bank",
        depotId: "Depotnummer",
        securityIsin: "ISIN",
        securityName: "Fondsname",
        date: "Datum",
        netCommission: "Provision",
        valuationBase: "Bewertungsbasis",
        commissionType: "Provisionstyp",
      },
      dashboard: {
        details: {
          title: "Provisions-Positionen",
          commission: "Provision auf",
          evaluation: "Bewertungssumme",
        },
        summary: {
          accountingFrom: "Abrechnung vom: ",
          download: "Abrechnung herunterladen",
          afterBilling: "Nach Abrechnung",
          notBilledYet: "Noch nicht abgerechnet",
          trailerCommission: "Bestandsprovision / Agio",
          commissionRetention: "Provisionseinbehalt",
          yourCashback: "Ihr Cashback",
          incomplete: "Abrechnung in Bearbeitung",
          lastBills: "Letzte Abrechnungen",
          goToBilling: "Gehe zu Abrechnungen",
          period: "Zeitraum:",
          taxHelper: "Steuerhelfer",
        },
        tabs: {
          overview: "Übersicht",
          invoices: "Abrechnungen",
          contacts: "Kontakt & Zahlung",
        },
        title: "Mein Cashback",
        breadcrumbs: {
          home: "Home",
          cashback: "Cashback",
        },
        titleAction: "Neue Cashback Buchung",
        openBookings: "Meine Cashback Buchungen",
        showAll: "Alle anzeigen",
        info: {
          title: "Freunde werben und doppelt profitieren",
          text: "Sichern Sie sich jetzt <blueText>{{amount}} € Cashback-Bonus*</blueText> für jeden geworbenen Freund.\nIhr Freund erhält ebenfalls <blueText>{{amount}} € Bonus.</blueText>",
          recommend: "{{appName}} weiterempfehlen",
          notNow: "Jetzt nicht",
        },
        cashbackBonusBanner: {
          amountText: "{{amount}} Bonus verfügbar",
          inactiveText: "• Aktivierung nach Abschluss der Buchung",
        },
        footer:
          "* Der Cashback-Bonus wird mit dem Provisionseinbehalt verrechnet und erhöht so Ihr Cashback.",
        item: {
          depositNumber: "Depotnnummer",
          edit: "Bearbeiten",
          abort: "Abbrechen",
          pdf: "PDF",
          deleteSuccess: "Die Cashback Buchung wurde erfolgreich gelöscht",
        },
        status: {
          incomplete: "Bitte Angaben vervollständigen",
          in_progress: "Bitte Unterlagen einreichen",
          internal_processing: "Unterlagen erhalten",
          processing_at_bank: "Unterlagen an Bank weitergeleitet",
          processing_at_bank_reduced:
            "Eröffnungsprozess an Bank weitergeleitet",
          processed: "Aktiv",
          contract_terminated: "Gekündigt",
          cancelled: "Abgebrochen",
        },
        taxHelper: {
          title: "Steuerhelfer",
          back: "zurück",
          categories: {
            EQUITY_FUND: "Aktienfonds, Aktienanteil > 51%",
            BALANCED_FUND: "Mischfonds, Aktienanteil > 25%",
            GERMAN_REAL_ESTATE_FUND: "Immobilien, Deutschland > 51%",
            FOREIGN_REAL_ESTATE_FUND: "Immobilien, Ausland > 51%",
            OTHERS: "Andere (Keine Freistellung)",
          },
          summary: {
            period: "Zeitraum",
            taxableAmount: "Steuerrelevanter Betrag",
            export: "Export",
            exportData: "Daten exportieren",
          },
          banner: {
            title: "Ausschluss der steuerlichen Beratung",
            text: "Die hier dargebotenen Informationen stellen keine steuerliche Beratung dar. Die angegebenen Werte und Software-Werkzeuge bieten lediglich eine Orientierungshilfe. Insbesondere übernimmt Rentablo keine Garantie für die angezeigten Werte und übernimmt auch keine Haftung. Eine individuelle Beratung durch fachkundige Personen kann dadurch nicht ersetzt werden.",
          },
          info: {
            title: "Teilfreistellungen",
            text: "Jeder Fonds, der eine Teilfreistellung der Erträge für seine Anleger gewährleisten will, muss in den Fondsbedingungen zukünftig die Quoten der Aktien- bzw. Immobilienanteile festschreiben und dem Bundesaufsichtamt für Finanzdienstleistungen (BaFin) nachweisen. Laut Gesetzgeber stellt der WM Datenservice die entsprechenden Daten zur Verfügung. In der Praxis ist der <linkText>WM Datenservice</linkText> leider nicht in der Lage, diese Daten auch bereitzustellen.",
            text2:
              "Aus diesem Grunde nehmen wir eine Vorklassifizierung basierend auf internen Daten und den Eingaben anderer Rentablo Benutzer vor. Bitte überprüfen Sie daher die angegebenen Werte.",
          },
          products: {
            name: "Produkt",
            category: "Steuerfreistellung",
            taxableAmount: "Steuerrelevanter Betrag",
            success: "Die Feistellung wurde erfolgreich aktualisiert",
          },
        },
      },
      form: {
        breadcrumbs: {
          home: "Home",
          contacts: "Kontakte",
          editContact: "Bearbeiten",
        },
        required: "Wird benötigt",
        accountData: "Kontodaten",
        payment: "Auszahlungskonto",
        cancel: "Abbrechen",
        save: "Änderungen speichern",
        recommend: "Empfehlung senden",
      },
      paymentDataForm: {
        nameWarning:
          "Bitte kontaktieren Sie unseren Support um den Namen des Kontoinhabers zu ändern",
        payment: "Auszahlungskonto",
        owner: "Kontoinhaber",
        iban: "IBAN",
        bank: "Bank",
        bic: "BIC",
        bankLocation: "Bankort",
        ownerData: "Kontoinhaber",
        lastName: "Nachname",
        firstName: "Vorname",
        ibanError: "Diese IBAN ist ungültig. Bitte überprüfen Sie die IBAN",
      },
      accountDataForm: {
        nameWarning:
          "Bitte kontaktieren Sie unseren Support um den Namen des Kontoinhabers zu ändern",
        title: "Kontoinhaber bearbeiten",
        accountData: "Auszahlungskonto",
        name: "Name Kontoinhaber",
        type: "Art",
        phone: "Telefon / Mobil (Für Rückfragen)",
        address: "Anschrift",
        street: "Straße",
        number: "Hausnummer",
        zip: "PLZ",
        city: "Ort",
        region: "Land",
        anschrift: "Anschirft",
      },
      contact: {
        owner: "Kontoinhaber",
        edit: "Bearbeiten",
        person: "PERSON",
        company: "FIRMENDEPOT",
        details: "Details ansehen",
      },
      invite: {
        breadcrumbs: {
          page: "{{appName}} weiterempfehlen",
        },
        title:
          "{{appName}} Cashback weiterempfehlen und {{amount}} € Bonus erhalten!",
        subtitle: "So funktioniert es",
        subtitle2:
          "Alternativ können Sie direkt hier eine Email mit Ihrem persönlichen Empfehlungs-Code versenden.",
        description:
          "Senden Sie Ihren persönlichen Empfehlungscode einfach per WhatsAPP oder SMS. Ihr Freund gibt diesen während der Buchung von {{appName}}-Cashback an.",
        myName: "Ihr Name",
        friendName: "Name Ihres Freundes",
        email: "Email Ihres Freundes",
        message: "Ihre Nachricht (optional)",
        send: "Senden",
        promotion: "Ihr Empfehlungscode",
        success:
          "Die E-Mail mit dem Code wurde erfolgreich an Ihren Freund gesendet",
      },
      breadcrumbs: {
        home: "Home",
        cashback: "Cashback",
      },
    },
    accountPreviewCard: {
      updateRecommended: "Aktualisierung empfohlen",
    },
  },
  questions: {
    INVESTMENT_HORIZON: {
      title: "Wie lange möchten Sie Ihr Geld anlegen?",
      subtitle: "Bitte wählen Sie Ihren Anlagehorizont aus",
      options: {
        LONG_TERM: {
          title: "Langfristige Geldanlage",
          subtitle: "Geldanlage mit einem Anlagehorizont über 7 Jahren",
        },
        MID_TERM: {
          title: "Mittelfristige Geldanlage",
          subtitle: "Geldanlage mit einem Anlagehorizont von 3 bis 7 Jahren",
        },
        SHORT_TERM: {
          title: "Kurzfristige Geldanlage",
          subtitle: "Geldanlage mit einem Anlagehorizont unter 3 Jahren",
        },
      },
    },
    SUSTAINABILITY: {
      title: "Wie wichtig ist Ihnen Nachhaltigkeit?",
      subtitle: "Bitte wählen Sie Ihre Präferenz",
      options: {
        MORE_IMPORTANT: {
          title: "Nachhaltigkeit ist mir wichtiger als Rendite",
          subtitle:
            "Nachhaltigkeit ist Priorität, ich würde auch auf höhere Rendite verzichten",
        },
        IMPORTANT: {
          title: "Nachhaltigkeit ist mir wichtig",
          subtitle: "Grundsätzlich wichtig, aber kein Ausschlusskriterium",
        },
        LESS_IMPORTANT: {
          title: "Rendite ist mir wichtiger als Nachhaltigkeit",
          subtitle:
            "Ich möchte eine gute Rendite, Nachhaltigkeit ist eher zweitrangig",
        },
        NOT_IMPORTANT: {
          title: "Ist mir nicht wichtig",
          subtitle: "Keine Präferenz",
        },
      },
    },
    RISK_RETURN_PREFERENCE: {
      title:
        "Wie würden Sie Ihre persönliche Chance-Risiko-Neigung einschätzen?",
      subtitle:
        "Wählen Sie die Antwortmöglichkeit, die am ehesten auf Sie zutrifft",
      options: {
        NO_RISK: {
          title: "Ich akzeptiere kein Verlustrisiko",
          tooltip: "Kein Risiko. Nur Festgeldprodukte mit festem Zinssatz.",
        },
        LOW_RETURN_EXPECTATION: {
          title:
            "Meine Ertragserwartung ist niedrig. Ich nehme geringe Kursschwankungen in Kauf.",
          tooltip: "Geringes Risiko. Anlagen mit Fokus auf Stabilität.",
        },
        MODERATE_RETURN_EXPECTATION: {
          title:
            "Ich habe eine moderate Ertragserwartung. Dafür nehme ich aufgrund von Marktschwankungen moderate Verlustrisiken in Kauf.",
          tooltip:
            "Mittleres Risiko. Anlagen mit Fokus auf langfristigem Kapitalwachstum.",
        },
        HIGH_RETURN_EXPECTATION: {
          title:
            "Ich habe eine hohe Renditeerwartung, die möglichst dauerhaft über dem Kapitalmarktzinsniveau liegt. Dafür nehme ich entsprechende Marktschwankungen und höhere Verlustrisiken in Kauf.",
          tooltip:
            "Hohes Risiko.  Anlagen mit Fokus auf Chancen und höherer Rendite.",
        },
      },
    },
    LIQUID_ASSETS: {
      title: "Wie hoch ist Ihr frei verfügbares Vermögen?",
      subtitle:
        "Die Angaben zu Ihren Vermögenswerten und Verbindlichkeiten helfen uns dabei, Ihre Risikotragfähigkeit zu bewerten und einen maximalen Anlagebetrag zu ermitteln.",
      CASH: "Wie hoch ist Ihr Barvermögen?",
      CASH_placeholder: "Bitte auswählen",
      cashAssetsOptions: {
        UNDER_20K: "Unter € 20.000",
        "20K_TO_50K": "€ 20.000 - € 50.000",
        "50K_TO_100K": "€ 50.001 - € 100.000",
        OVER_100K: "Über € 100.000",
      },
      ASSETS_IN_SECURITIES:
        "Wie hoch ist Ihr Vermögen, dass Sie in Wertpapieren angelegt haben?",
      ASSETS_IN_SECURITIES_placeholder: "Bitte auswählen",
      securitiesOptions: {
        UNDER_20K: "Unter € 20.000",
        "20K_TO_50K": "€ 20.000 - € 50.000",
        "50K_TO_100K": "€ 50.001 - € 100.000",
        OVER_100K: "Über € 100.000",
      },
    },
    NET_INCOME_AND_NET_EXPENSES: {
      title: "Welche Erfahrungen und Kenntnisse haben Sie mit Fonds und ETF?",
      subtitle:
        "Wir möchten sicher gehen, dass Sie sich mit Ihren Anlageprodukten wohlfühlen. Daher fragen wir, inwieweit Sie schon Erfahrungen mit bestimmten Anlagen gesammelt haben.",
      YEARS_INVESTING_FUNDS:
        "Erfahrung - Seit wie vielen Jahren investieren Sie in das genannte Finanzinstrument?",
      investingYearsOptions: {
        NO_INVEST: "Keine Erfahrung",
        UP_TO_1: "Bis zu 1 Jahr",
        UP_TO_3: "Bis zu 3 Jahren",
        OVER_3: "Mehr als 3 Jahre ",
      },
      KNOWLEDGE_FUNDS:
        "Kenntnisse - Wie vertraut sind Sie mit der Funktionsweise, den Chancen und den Risiken des Finanzinstruments?",
      knowledgeOptions: {
        NO_KNOWLEDGE: "Keine Kenntnisse",
        LOW_KNOWLEDGE: "Wenig Kenntnisse",
        MEDIUM_KNOWLEDGE: "Mittlere Kenntnisse",
        HIGH_KNOWLEDGE: "Viele Kenntnisse",
      },
      TRADES_PER_YEAR_FUNDS: "Durchschnittliche Anzahl Geschäfte / Jahr",
      averageFundTransactionsOptions: {
        "1_TO_4": "0 bis 4",
        "5_TO_10": "5 bis 10",
        "11_TO_50": "11 bis 50",
        OVER_50: "Mehr als 50",
      },
    },
    PREFERENCE_ETF_OR_FUNDS: {
      title: "Präferieren Sie ETF oder klassische Fonds bei Ihrer Anlage?",
      infoBox: {
        title: "Der Unterschied zwischen ETF und Investmentfonds",
        text: "Ziel von klassischen Investmentfonds ist es, einen Index zu übertreffen, während Exchange Traded Funds (ETF) die jeweiligen Indizes abbilden. Investmentfonds werden von einem Fondsmanagement aktiv verwaltet, wohingegen ETF auf ein aktives Fondsmanagement verzichten. Anleger müssen für das aktive Fondsmanagement höhere Gebühren als für passiv gemanagte  ETF zahlen.",
      },
      subtitle:
        "Wir möchten sicher gehen, dass Sie sich mit Ihren Anlageprodukten wohlfühlen. Daher fragen wir Sie nach Ihren Präferenzen für bestimmte Anlagen.",
      options: {
        ETF: {
          title: "ETF",
          subtitle: "Kein aktives Fondsmanagement",
        },
        FUNDS: {
          title: "Klassische Fonds",
          subtitle: "Aktives Fondsmanagement",
        },
        NO_PREFERENCE: {
          title: "Ist mir nicht wichtig",
          subtitle: "Keine Präferenz",
        },
      },
    },
    age: {
      title: "Wie alt sind Sie?",
      subtitle: "Bitte wählen Sie Ihr Alter aus",
      age: "Alter",
      options: {
        "under-18": "unter 18",
        "18-25": "18 bis 25 Jahre",
        "26-40": "26 bis 40 Jahre",
        "41-60": "41 bis 60 Jahre",
        "over-60": "über 60 Jahre",
      },
    },
    children: {
      title: "Wie viele Kinder haben Sie?",
      subtitle: "Bitte geben Sie die Nummer an",
      children: "Anzahl Kinder",
    },
    income: {
      title: "Wie hoch sind Ihre monatlichen Einnahmen und Ausgaben?",
      subtitle:
        "Bitte machen Sie realistische Angaben damit wir Ihnen die Geldanlage vorschlagen können, die am besten zu Ihnen passt.",
      income: "Monatliche Nettoeinnahmen",
      expenses: "Monatliche Ausgaben",
      options: {
        income: {
          "under-1000": "Under 1.000 euros",
          "1000-1500": "1.000 - 1.500 euros",
          "1501-2500": "1.501 - 2.500 euros",
          "over-2500": "Over 2.500 euros",
        },
        expenses: {
          "under-1000": "Under 1.000 euros",
          "1000-1500": "1.000 - 1.500 euros",
          "1501-2500": "1.501 - 2.500 euros",
          "over-2500": "Over 2.500 euros",
        },
      },
    },
  },
  productBasicInfo: {
    title: "Stammdaten",
    savingsPlan: {
      title: "Sparplan-fähig",
    },
    vl: {
      title: "VL-fähig",
    },
    distribution: {
      title: "Aussch. Art",
      RETAINED: "Thesaurierend",
      DISTRIBUTING: "Ausschüttend",
    },
    distributionFrequency: {
      title: "Aussch. Intervall",
      monthly: "Monatlich",
      quarterly: "Quartalsweise",
      biAnnually: "Halbjährlich",
      annually: "Jährlich",
    },
    currency: {
      title: "Währung",
    },
    age: {
      title: "Alter",
      value_one: "{{years}} Jahr",
      value_other: "{{years}} Jahre",
      valueMonth_one: "{{months}} Monat",
      valueMonth_other: "{{months}} Monate",
    },
    establishedAt: {
      title: "Auflage",
    },
    volume: {
      title: "Volumen",
    },
  },
  gaugeChart: {
    risk: "Risiko",
    performance: "Perf.",
    riskClass: {
      extremelyLow: "Äußerst gering",
      veryLow: "Sehr gering",
      low: "Gering",
      medium: "Mittel",
      high: "Hoch",
      veryHigh: "Sehr hoch",
      extremelyHigh: "Äußerst hoch",
      unknown: "Unbekannt",
    },
    performanceClass: {
      negative: "Negativ",
      veryLow: "Sehr gering",
      low: "Gering",
      medium: "Mittel",
      high: "Hoch",
      veryHigh: "Sehr hoch",
      top: "Top",
      unknown: "Unbekannt",
    },
  },
  performanceTags: {
    title: "Kursentwicklung",
    tags: "Tags",
  },
  performanceGauges: {
    risk: "Risiko",
    riskClass: "Risiko-Klasse",
    riskTooltip:
      "Jedes Produkt wird einer Risikoklasse zugeordnet. Die Einteilung in 7 Klassen erfolgt anhand der Volatilität. Die Volatilität wird als annualisierte Standardabweichung der Tagesrenditen für den pro Strategie verfügbaren Zeitraum angegeben.",
    performance: "Performance",
    performanceClass: "Performance-Klasse",
    performanceTooltip:
      "Jedes Produkt wird einer Performanceklasse zugeordnet. Die Einteilung in 7 Klassen erfolgt anhand der annualisierten Rendite. Diese wird auf Basis der historischen Performance für den pro Strategie verfügbaren Zeitraum berechnet.",
    volatility: "Volatilität (1J / 3J)",
    noData: "N/A",
  },
  performanceNumbers: {
    value: "Wert",
    actual: "Aktuell",
  },
  cashflowAnalyzer: {
    title: "Budget",
    accountsBalance: "Kontostand",
    actualMonth: "Aktueller Monat",
    mean: "Durchschnitt",
    chartTitle: "Einnahmen & Ausgaben nach Kategorie",
    bannerTitle:
      "Ihre Ausgaben lagen diesen Monat <red>{{amount}}</red> über Ihren Durchschnittswert",
    income: "Einnahmen",
    expenses: "Ausgaben",
    balance: "Liquide Mittel",
    monthly: "Monate",
    quarterly: "Quartale",
    yearly: "Jahre",
    total: "Gesamtausgaben",
    sankeyChart: {
      noExpenses: "Keine Ausgaben",
    },
    chartSwitcher: {
      flow: "Fluss",
      distribution: "Verteilung",
    },
    chart: {
      period: "Zeitraum",
    },
    transactionsTable: {
      title: "Transaktionen",
      showMore: "Mehr Transaktionen anzeigen",
      noData: "Keine Transaktionen für den Zeitraum",
      filter: "Filter",
      thisTransactionIs: "Diese Transaktion ist",
      category: "Kategorie",
      regular: "Regelmäßig",
      accountTransfer: "ein Kontentransfer",
      account: "Konto",
      counterpart: "Gegenstelle",
    },
    categoryModal: {
      searchPlaceholder: "Schnellsuche Kategorie",
      title: "Kategorie ändern",
      addCategory: "Neue Kategorie hinzufügen",
      back: "Zurück",
      save: "Speichern",
    },
    addCategoryModal: {
      title: "Neue Kategorie hinzufügen",
      main: "Oberkategorie erstellen",
      sub: "Unterkategorie erstellen",
      mainCategory: "Oberkategorie wählen",
      mainCategory_placeholder: "Bitte auswählen",
      subCategoryName: "Unterkategorie erstellen",
      subCategoryName_placeholder: "Neue Kategorie",
      mainCategoryName: "Kategorie erstellen",
      mainCategoryName_placeholder: "Neue Kategorie",
      created: "Kategorie wurde erfolgreich erstellt",
      deleted: "Kategorie wurde erfolgreich gelöscht",
      assigned: "Kategorie wurde erfolgreich zugewiesen",
    },
    statistic: {
      currentMonth: "Aktueller Monat",
      average: "Durchschnitt",
      revenue: "Einnahmen",
      expenditure: "Ausgaben",
      liquidAssets: "Liquide Mittel",
    },
  },
  contractAdminPage: {
    title: "Provider Name",
    breadcrumb: "Provider Name",
    searchLabel: "Hier können Sie nach Provider Namen suchen",
    searchPlaceholder: "Name eingeben",
    table: {
      name: "Name",
      iban: "IBAN",
      category: "Katagorie",
      subCategory: "Sub-Kategorie",
      popularity: "Popularität",
      status: "Stand",
      date: "Date",
      done: "Done",
    },
    buttonText: "Done",
    tooltip: {
      userSuggestions: "User Vorschläge für Provider-Name",
      edit: "Bearbeiten",
    },
    noData: "Keine Klassifizierungsdaten verfügbar",
    modal: {
      title: "Diesen Eintrag auf erledigt setzen?",
      subtitle: "Diese Aktion kann nicht rückgängig gemacht werden.",
      cancelButton: "Nein",
      confirmButton: "Ja",
      success: "Eintrag erfolgreich erledigt.",
      error:
        "Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal",
    },
  },
  settings: {
    changesSaved: "Änderungen gespeichert",
    errorOccurred: "Ein Fehler ist aufgetreten",
    sidebar: {
      title: "Einstellungen",
      common: {
        title: "Allgemein",
        profile: "Profil",
        notifications: "Benachrichtigungen",
        premium: "Premium Pakete",
        advanced: "Einstellungen Bankimport",
      },
      bankConnections: {
        title: "Bankverbindungen",
        noAccountsTooltip:
          "Zu dieser Bankverbindung existieren bislang keine Konten oder Depots. Bevor die Bankverbindung erneut aufgebaut wird, bitte zuerst die bestehende Bankverbindung löschen. Damit werden potentielle Probleme beim Import von Konten oder Depots vermieden.",
      },
      twoFA: {
        title: "Sicherheitseinstellungen",
      },
      userId: {
        label: "USER ID",
        tooltip:
          "Das ist Deine UserID. Du benötigst diese ID z.B. bei Support-Anfragen oder zur Verbindung mit KICS.",
      },
    },
    twoFA: {
      title: "Sicherheitseinstellungen",
      subtitle: "Zwei-Faktor-Authentifizierung",
      codeLabel: "Code eingeben",
      methods: {
        title: "Ihre 2FA-Methode",
        subtitle:
          "Die Zwei-Faktor-Authentifizierung generiert für jeden Anmeldevorgang einen individuellen, temporär gültigen Sicherheitscode. In der folgenden Übersicht werden Ihnen mögliche Apps vorgeschlagen.",
        googleAuth: "Google Authenticator",
        microsoftAuth: "Microsoft Authenticator",
        linkForAndroid: "Link für Android",
        linkForApple: "Link für Apple",
      },
      disabled: {
        description:
          "Schützen Sie Ihren Account, indem Sie die Zwei-Faktor-Authentifizierung (2FA) aktivieren. Zur Einrichtung wird eine sogenannte Authentifizierungs-App benötigt (Auswahl siehe unten).",
        toggle: "Zwei-Faktor-Authentifizierung aktivieren",
      },
      enabled: {
        description:
          "Ihr Account ist durch die Zwei-Faktor-Authentifizierung (2FA) geschützt.",
        description1:
          "Um die Zwei-Faktor-Authentifizierung zu deaktivieren, nutzen Sie den Umschalter und geben Sie den bereitgestellten Einmalcode ein.",
        toggle: "Zwei-Faktor-Authentifizierung deaktivieren",
      },
      setup: {
        step1: {
          title: "Schritt 1 - Sichern Sie Ihr Konto",
          subtitle:
            "Scannen Sie den untenstehenden QR-Code mit Ihrer bevorzugten Authenticator-App und geben Sie anschließend den bereitgestellten Einmalcode unten ein.",
        },
        step2: {
          title: "Schritt 2",
          subtitle: "Geben Sie den Zwei-Faktor-Verifizierungscode ein.",
        },
        confirmButton: "2FA aktivieren",
      },
      disable: {
        description: "Geben Sie den Zwei-Faktor-Verifizierungscode ein.",
        disableButton: "2FA deaktivieren",
      },
      messages: {
        error: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
        qrLoadError:
          "QR-Code konnte nicht geladen werden. Bitte erneut versuchen.",
        invalidCodeError:
          "Ungültiger oder abgelaufener 2FA Code. Bitte versuchen Sie es erneut.",
        disableSuccess: {
          title: "Zwei-Faktor-Authentifizierung",
          text: "Die Zwei-Faktor-Authentifizierung Ihres Kontos wurde deaktiviert.",
        },
        enableSuccess: {
          title: "Zwei-Faktor-Authentifizierung",
          text: "Die Zwei-Faktor-Authentifizierung wurde aktiviert.",
        },
      },
    },
    profile: {
      title: "Ihr Benutzerprofil",
      subtitle: "Passe deine Benutzerdaten an",
      avatar: {
        title: "Avatar / Benutzerbild",
        upload: "Avatar hochladen",
        replace: "Avatar ersetzen",
        delete: "Löschen",
        info: "Wir unterstützen PNGs, JPEGs mit einer Dateigröße unter 10MB.",
      },
      form: {
        gender: "Anrede",
        academicTitle: "Titel",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "Email Adresse",
        oldEmail: "Aktuelle Email Adresse",
        newEmail: "Neue Email Adresse",
        newEmail_placeholder: "Ihre neue Email Adresse",
        newEmailConfirmation: "Neue Email Adresse wiederholen",
        newEmailConfirmation_placeholder: "Ihre neue Email Adresse",
        oldPassword: "Aktuelles Passwort",
        forgotPassword: "Passwort vergessen",
        oldPassword_placeholder: "Bitte geben Sie Ihr aktuelles Passwort ein",
        newPassword: "Neues Passwort festlegen",
        newPassword_placeholder: "Bitte legen Sie ein Passwort fest...",
      },
      emailEditLink: "Email Adresse ändern",
      passwordEditLink: "Passwort ändern",
      emailEditModal: {
        title: "Email ändern",
        subtitle: "Geben Sie Ihre neue Email Adresse an",
        close: "Schließen",
        submit: "Emailadresse ändern",
        success:
          "Wir haben eine Bestätigungs-Email an <strongText>{{email}}</strongText> gesendet. Ihre alte Email-Adresse bleibt bis zur Bestätigung gültig.",
      },
      passwordEditModal: {
        title: "Password ändern",
        subtitle: "Geben Sie Ihre neue Passwort ein",
        close: "Abbrechen",
        submit: "Passwort ändern",
        success: "Ihr Passwort wurde erfolgreich geändert",
        forgotPassword: "Passwort vergessen",
        error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
      },
      emailChangeSuccess: "Email Adresse geändert",
      emailChangeError:
        "Email Adresse konnte nicht geändert werden. Bitte kontaktieren Sie unseren Support.",
    },
    notifications: {
      title: "Benachrichtigungen",
      subtitle: "Passe deine Benachrichtigungen an",
      banner: {
        title: "Alle Benachrichtigungen deaktiviert",
        subtitle: "Sie erhalten aktuell keine Benachrichtigungen",
      },
      form: {
        investmentReportFrequency: "Investment-Report",
        investmentReportFrequency_weekly: "Wöchentlich",
        investmentReportFrequency_monthly: "Monatlich",
        investmentReportFrequency_never: "Nie",
        emailNotification: "Automatische Benachrichtigung bei Depot-Updates",
        emailNotification_yes: "Ja",
        emailNotification_no: "Nein",
      },
      newsLetters: {
        title: "Rentablo Newsletter verwalten",
        description:
          "Der WealthAPI Newsletter informiert über neue Features und interessante Blogeinträge. Wir werden uns hierbei auf relevante Informationen beschränken. Die Frequenz halten wir bewusst gering, um Ihnen nicht unnötig die Inbox zu füllen.",
        subscribe: "Newsletter abonnieren",
        unsubscribe: "Newsletter abbestellen",
      },
    },
    advanced: {
      title: "Erweitert",
      subtitle:
        "Passen Sie die erweiterten Funktionen an, die Ihren Account betreffen",
      bankImport: {
        title: "Bankimport Verbindungeinstellungen",
      },
      deleteConnection: {
        title: "Alle finAPI Bankverbindungsdaten löschen",
        text: "Löschen Sie Ihre gesamten, bei <linkText>finAPI</linkText> gespeicherten Daten. Bereits importierte Daten bleiben erhalten. Eine Synchronisierung Ihrer Depots und Konten ist danach nicht mehr möglich.",
        info: "Falls Sie lediglich einen gespeicherten Bank-Login löschen möchten, so tun Sie das bitte hier in der Kontoverwaltung",
        buttonText: "Bankdaten löschen",
        deleteConnectionConfirmModal: {
          title: "Sind Sie sich sicher?",
          text: "Wenn Sie Ihre Bankverbindung löschen, findet keine automatische Depot- und Kontenaktualisierung mehr statt.",
          cancel: "Abbrechen",
          confirm: "Verbindung löschen",
        },
      },
      tracking: {
        title: "Tracking",
        text: "Helfen Sie uns, {{appName}} durch Statistiken zu Websitenutzung und Benutzerverhalten zu verbessern. Die Daten werden ausschließlich zur Verbesserung unseres Web-Auftrittes verwendet.",
        buttonTextOff: "Zustimmung widerrufen",
        buttonTextOn: "Zustimmung geben",
      },
      deleteAccount: {
        title: "{{appName}} Account dauerhaft schließen",
        text: "Hiermit schließen Sie Ihren {{appName}} Account. Ihre Daten werden hierdurch unwiderruflich gelöscht. Ein Zugriff auf Ihren Account ist nach der Schließung nicht mehr möglich.",
        info: "Dieser Vorgang kann nicht rückgängig gemacht werden!",
        buttonText: "{{appName}} Account löschen",
        deleteAccountConfirmModal: {
          title: "Sind Sie sich sicher?",
          text: "Ihr Account wird geschlossen und alle Daten unwiderruflich gelöscht. Weiterer Zugriff ist dann nicht mehr möglich.",
          cancel: "Abbrechen",
          confirm: "Account löschen",
          success: "Ihr Account wurde erfolgreich gelöscht",
        },
      },
      deletePortalAccount: {
        title: "Account dauerhaft löschen",
        note: "Durch die Löschung Ihres Accounts werden alle Daten unwiderruflich entfernt. Ein Zugriff auf <bold>{{portalName}}</bold> ist dann nicht mehr möglich.",
        buttonText: "Account löschen",
      },
    },
    bankConnection: {
      subtitle: "Konten und Depots verwalten",
      accounts: {
        title: "Konten",
        menu: {
          deleteSavedPins: "Gespeicherte Pins löschen",
          deleteBankDetails: "Bankverbindung löschen",
        },
      },
      accountTypes: {
        1: "Girokonto",
        2: "Sparkonto",
        3: "Kreditkarte",
        4: "Depot",
        5: "Darlehenskonto",
        6: "Girokonto",
        7: "Mitgliedschaft",
        8: "Bausparen",
        21: "Verrechnungskonto",
        22: "Währungskonto",
        "01_depot": "Depot",
        "02_cash": "Girokonto",
      },
      deletePinsModal: {
        title: "Sind Sie sich sicher?",
        text: "Bei der nächsten Aktualisierung des Kontos / Wertpapier-Depots fragt {{appName}} Ihre neue Banking-PIN ab.",
        cancel: "Abbrechen",
        submit: "Pins löschen",
        error:
          "Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal",
        success: "Pins wurden erfolgreich gelöscht",
      },
      deleteBankConnectionModal: {
        title: "Sind Sie sich sicher?",
        text: "Wenn Sie Ihre Bankverbindung löschen, findet keine automatische Depot- und Kontenaktualisierung mehr statt.",
        cancel: "Abbrechen",
        submit: "Verbindung löschen",
        error:
          "Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal",
        success: "Die Verbindung wurde erfolgreich gelöscht",
      },
      interfaces: {
        title: "Schnittstellen",
        active: "Active",
        info: "{{appName}} ermöglicht den Zugang zu rund 3.500 Bankanbindungen. Die entsprechenden Schnittstellen (API) werden vor allem von unserem Partner finAPI zur Verfügung gestellt. Darüber hinaus hat {{appName}} einige Banken und Broker via Direkt-API selbst angebunden. Dies sind unter anderem comdirect, Trade Republic, Whitebox, Quirion und Scalabe.",
        actualized: "Aktualisiert",
      },
    },
  },
  components: {
    depotSelect: {
      label: "Depot oder Konten wählen",
      types: {
        "01_depot": "DEPOTS",
        "02_cash": "KONTEN",
      },

      modal: {
        title: "Neues Depot erstellen",
        name: "Depotname",
        name_placeholder: "Depotname",
        save: "Erstellen",
      },
    },
    bankSearchField: {
      label: "Bitte wählen Sie Ihre Bank aus",
      placeholder: "Name, ISIN oder WKN eingeben",
    },
    depotsStatistic: {
      showHistoricSwitch: "Historische anzeigen",
      tabs: {
        export: "Export CSV",
        investments: "Investments",
        bookings: "Buchungen",
      },
      bookingsTable: {
        noItems: "Keine Buchungen",
        headers: {
          investmentType: "Investment",
          name: "Name",
          price: "Kaufpreis",
          amount: "Wert (Gesamt)",
        },
        lots: "St.",
      },
      chart: {
        subheader: {
          performance: "Gesamtwert:",
          valuation: "Einstandswert:",
        },
        typeSwitcher: {
          performance: "Performance",
          valuation: "Wertentwicklung",
        },
      },
    },
    watchlistsCreateAndEditForm: {
      form: {
        nameInputLabel: "Neue Watchlist",
        saveButton: "Speichern",
      },
    },
    AssetTypeCard: {
      ytd: "YTD",
    },
    quotes: {
      quoteChartContainer: {
        subheader: "Aktueller Wert",
      },
    },
    layouts: {
      showcaseLayout: {
        imageAlt: "{{appName}} Firmenzeichen",
      },
    },
  },
  aboutCompany: {
    support: {
      phone: "(0) 30 - 71 53 30 10",
      phoneLink: "+03071533010",
      phoneInfo: "Mo. bis Fr. 9-19 Uhr erreichbar",
      email: "{{supportEmail}}",
    },
    company: {
      name: "{{appName}}, eine Marke der wealthAPI GmbH",
      street: "Fanny-Zobel-Str.",
      streetNumber: "9",
      zip: "12435",
      city: "Berlin",
      claim: "Das kostenfreie Tool für Ihren Finanzerfolg",
    },
    brand: {
      name: "{{appName}}",
    },
    media: {
      email: "presse@bn.de",
      b2bEmail: "presse@wealthapi.eu",
    },
    b2b: {
      name: "wealthAPI GmbH",
      claim: "Smart Financial Decisions",
      email: "info@wealthapi.eu",
      privacyEmail: "datenschutz@wealthapi.eu",
      website: "https://wealthapi.eu",
    },
  },
  docs: {
    agb: {
      title: "AGBs",
    },
    disclaimer: {
      title: "Haftungsausschluss",
    },
    impressum: {
      title: "Impressum",
    },
    privacy: {
      title: "Datenschutz",
    },
  },
  feedbackGlobalButton: {
    tooltip: "Feedback",
  },
  navigation: {
    cancel: "Abbrechen",
    previous: "Zurück",
    next: "Weiter",
    save: "Speichern",
    deleteModal: {
      errorTitle: "Fehler",
      confirmTitle: "Wirklich löschen?",
      yes: "Ja",
      no: "Nein",
      close: "Schließen",
      cannotBeUndone: "Diese Aktion kann nicht rückgängig gemacht werden.",
    },
  },
  somethingWrong: {
    loginFailed: "Login fehlgeschlagen, bitte prüfen Sie Email und Passwort",
    shortTitle: "Es ist ein Fehler aufgetreten.",
    subTitle:
      "Bitte versuchen Sie es nochmals. Kontaktieren Sie unseren Support unter {{supportEmail}}, sollte dieses Problem mehrfach auftreten.",
    title:
      "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmals. Kontaktieren Sie unseren Support unter {{supportEmail}}, sollte dieses Problem mehrfach auftreten.",
    message: "{{message}}.",
    eventIdMessage: "Die Fehler-ID ist: {{eventId}}",
    reload: "Seite neu laden",
  },
  company: {
    name: "Rentablo GmbH",
    customerService: "Kundenservice",
    street: "Fanny-Zobel-Straße 9",
    zip: "12435",
    city: "Berlin",
  },
  cashback: {
    "50": "Cashback-50",
    "100": "Cashback-100",
    "50upTo": "bis ca. 75.000 €",
    "100from": "ab ca. 75.000 €",
  },
  terms: {
    agb: "Nutzungsbedingungen",
    impressum: "Impressum",
  },
  ranges: {
    years: {
      oneYear: "1 Jahr",
      threeYears: "3 Jahre",
      fiveYears: "5 Jahre",
      tenYears: "10 Jahre",
    },
    max: "Max",
  },
  accountTypes: {
    "01_depot": "Depot",
    "02_cash": "Konten",
    "04_insurance": "Versicherungen",
    "05_material_assets": "Edelmetalle & Sachwerte",
    "06_crypto": "Crypto",
    "07_real_estate": "Immobilien",
    bankSelect: {
      label: "Bank Name, BIC oder IBAN",
      noOptions: "Keine Optionen",
      bankName: "Bank name",
      bic: "BIC",
    },
  },
  bookingTypes: {
    buy: "Kauf",
    sell: "Verkauf",
    dividend: "Dividende",
    book_in: "Einbuchung",
    book_out: "Ausbuchung",
    split: "Split",
    reverse_split: "Reverse Split",
    retained_dividend: "Thes. Dividende",
    purchase_right: "Bezugsrecht",
    pre_tax_allowance: "Vorabpauschale",
    carve_out: "Carve Out",
    switch: "Switch",
    cap_gains_tax: "Kapitalertragsteuer",
    cap_gains_tax_refund: "Kapitalertragsteuer-Erstattung",
    fees: "Gebühren",
  },
  investmentTypes: {
    "11_stock": "Aktie",
    "21_fund": "Fonds",
    "22_etf": "ETF",
    "31_bond": "Anleihe",
    "41_cash": "Cash",
    "51_certos": "Zertifikat / OS",
    "61_pmetals": "Edelmetall",
    "71_massets": "Sachwert / Immobilie",
    "81_fcurr": "Fremdwährung",
    "91_managed": "Robo / Vermögensverwaltung",
    "92_other": "Sonstiges",
  },
  quantities: {
    pieces: "Stück",
    percent: "Prozent",
  },
  signupWizard: {
    restoreWizardDialog: {
      title:
        "Es liegt eine nicht abgeschlossene Buchung vor. Möchten Sie diese vervollständigen oder abbrechen?",
      contentText: "Es kann nur eine unvollständige Buchung vorliegen.",
      continueButton: "Vervollständigen",
      startNewButton: "Abbrechen und neu starten",
    },
    validation: {
      isNotEmpty: "wird benötigt",
      isNotEmptyArray: "wird benötigt",
      isPhoneNumber: "Ist keine gültige Telefonnummer",
      isPassword: "Das Passwort muss mindestens 8 Zeichen haben",
      isAgbAccepted: "Sie müssen unsere AGB akzeptieren",
      isEmail: "Die Email-Adresse ist ungültig",
      isPayoutBank: "Die angegebene IBAN ist nicht korrekt",
      isComdirectCustomerNumber: "muss aus 10 Zahlen bestehen (0-9)",
      isEbaseDepotNumber: "muss aus 10 oder 11 Zahlen bestehen (0-9)",
      isDabAccountNumber: "muss aus 7 Zahlen bestehen (0-9)",
      isAugsburgerAktienbankDepotNumber: "Muss aus 10 Zahlen bestehen (0-9)",
      isDwsDepotNumber: "ein Buchstabe, gefolgt von 7 Zahlen",
      isFfbDepotNumber: "muss aus 10 Zahlen bestehen (0-9)",
      isFondsdepotDepotNumber: "muss aus 10 Zahlen bestehen (0-9)",
      isMetzlerDepotNumber: "muss aus 10 Zahlen bestehen (0-9)",
      isStreetWithNumber: "wird benötigt",
    },
    cashbackProcessIntroduction: {
      heading: "In wenigen Schritten zu Ihrem Cashback:",
      enterData: "Daten eingeben",
      print: "Ausdrucken",
      sendToUs: "An uns senden",
      youRequire:
        "Sie benötigen ca. <1>5 Minuten</1>. Falls Sie bereits Kunde einer {{appName}} Partnerbank sind, halten Sie bitte Ihre Depot- bzw. Kundennummer bereit.",
      startNow: "Jetzt starten",
      thatIsHowWeCalculateCashback: "So berechnen wir Ihr Cashback",
      depotSize: "Depotvolumen",
      bestPriceGuarantee:
        "<0>Bestpreis-Garantie:</0> wir wählen bei jeder Abrechnung das für Sie beste Cashback-Modell",
      onceForAllYourDepots: "unabhängig von der Anzahl Ihrer Depots",
      discountOnAgio: "Rabatt Ausgabeaufschlag",
      cost: "Sie zahlen",
      noCost: "Nichts",
      youReceive: "Ihr Cashback",
      "50percentCashback": "50 % der Bestandsprovision (max. 15 €)",
      "100percentCashback": "100 % der Bestandsprovision",
      administrationFee: "15 € / Monat",
      administrationFeeDetails: "(mit Cashback verrechnet)",
      rentabloReceives: "{{appName}} erhält",
      moreAssetsMoreCashback: "Erhalten Sie bis zu 100% Cashback",
      seeIllustration: "Siehe interaktiver Chart",
    },
    cashbackSummary: {
      heading: "PDF jetzt ausdrucken",
      printOutNote:
        "Ihr Cashback Antrag wurde erstellt und liegt zum Download bereit.",
      printedOutQuestion: "Ausgedruckt?",
      foundAMistake: "Sie haben einen Fehler gefunden",
      correctDataButton: "Daten bearbeiten",
      print: "Hier drucken",
      printPdf: "Antrag ausdrucken",
      nextStepsButton: "Nächste Schritte",
      wouldYouLikeToCorrectYourData: "Möchten Sie Ihre Daten korrigieren?",
    },
    cashbackNextSteps: {
      heading: "Super, fast fertig!",
      reviewForms: "Bitte prüfen Sie den generierten Antrag.",
      printOutAndSign:
        "Bitte <1>unterschreiben Sie die ausgedruckten Dokumente</1> und senden Sie diese an uns zurück!",
      sendBack: "Dokumente zurücksenden",
      sendBackDescription: "Ein Rücksende-Formular liegt bei.",
      identifyViaPostident: "und <1>Identifikation über PostIdent</1>",
      identifyViaPostidentDescription:
        "Bitte identifizieren Sie sich mit dem beiliegenden PostIdent Formular bei der Post.",
      identifyViaRentablo:
        "und <1>legen Sie eine Kopie Ihres Personalausweises / Reisepass bei</1>",
      identifyViaRentabloDescription:
        "Wir legitimieren Sie im Zuge der Depoteröffnung. Unsere Mitarbeiter kontaktieren Sie nach Erhalt der Dokumente.",
      birthCertificate: "legen Sie eine <1>Geburtsurkunde</1> bei",
      birthCertificateDescription:
        "Bitte fügen Sie eine Kopie der Geburtsurkunde des Minderjährigen bei. Diese wird von der Bank im Rahmen der Kontoeröffnung benötigt.",
      allDone: "Fertig!",
      backButton: "Zurück zur Buchung",
      addAnotherDepot: "Ein weiteres Depot hinzufügen",
      altExit: "oder",
      backToMainPage: "Weiter zur Übersicht",
    },
    cashbackNextStepsForCompany: {
      heading: "Super, so geht es jetzt weiter...",
      dataReceived: "Wir haben Ihre Anfrage zur Depoteröffnung erhalten",
      weWillContactYou: "Wir werden uns in Kürze bei Ihnen melden",
      weWillContactYouDescription:
        "Leider ergeben sich bei der Eröffnung von Firmendepots häufige Änderungen in den Abläufen der jeweiligen Bank. Einer unserer Mitarbeiter wird Sie daher in Kürze mit Details zur Depoteröffnung kontaktieren.",
      contactUs:
        "Sollten Sie innerhalb des nächsten Arbeitstages keine Rückmeldung von uns erhalten haben, so senden Sie uns gerne eine Email an <1>{{supportEmail}}</1> oder rufen Sie uns einfach unter der <1>030 - 71533009</1> an.",
    },
    selectNewOrExistingDepotStep: {
      naturalPerson: "Privatkunden",
      legalPerson:
        "Juristische Personen (UGs, GmbHs, AGs, Stiftungen, Vereine)",
      newDepot: "Neues Depot eröffnen",
      newCompanyDepot: "Neues Firmen-Depot eröffnen",
      existingDepot: "Ich führe bereits ein Depot",
      existingCompanyDepot: "Meine Firma führt bereits ein Depot",
      question: "Bitte wählen Sie:",
    },
    companyDepotTermsStep: {
      question: "Hinweis: Bedingungen für Firmendepots",
      terms:
        "Firmendepots unterscheiden sich in Größe und Betreuungsaufwand erheblich von Privatkunden-Depots. Aus diesem Grund beträgt Ihr Cashback <1>pauschal 80 %</1> der an {{appName}} ausgekehrten Bestandsprovisionen, ab dem ersten Euro.",
      oneClick:
        "Darüber hinaus steht Ihnen kostenfrei der {{appName}} One-Click Import zur einfachen Verwaltung Ihres Firmendepots zur Verfügung.",
    },
    selectBankStep: {
      question: "Bei welcher Bank möchten Sie Ihr Cashback-Depot eröffnen?",
      onvistaQuestion:
        "Bei welcher Partnerbank möchten Sie Ihr onvista-Cashback Depot eröffnen?",
      recommendedBankHeading:
        "Aufgrund des hervorragenden Service empfehlen wir die comdirect",
    },
    selectRecommendedBankStep: {
      question: "Bei welcher Bank möchten Sie Ihr Cashback-Depot eröffnen?",
      recommendedBankHeading:
        "Aufgrund des hervorragenden Service empfehlen wir die comdirect",
    },
    selectExistingDepotStep: {
      question:
        "Bei welcher der {{appName}} Partnerbanken führen Sie Ihr Depot?",
      noDepotYet: "Noch kein Depot bei einer {{appName}} Partnerbank?",
      openDepot: "Jetzt eröffnen.",
    },
    emailStep: {
      question: "Was ist Ihre Email-Adresse?",
      placeholder: "Email-Adresse",
    },
    passwordStep: {
      question: "Bitte legen Sie ein sicheres Passwort fest",
      placeholder: "Passwort (min. 8 Zeichen)",
    },
    acceptTermsAndConditionsStep: {
      question: "Bitte bestätigen Sie unsere AGB",
      agb: "Mit der Registrierung akzeptiere ich die <1>Allgemeinen Geschäftsbedingungen</1> und die <3>Datenschutzbestimmungen</3>*",
      newsLetters:
        "Ich möchte über neue Funktionen und Sparangebote informiert werden",
      accountCreationFailed:
        "Entschuldigung, aber wir konnten das Benutzerkonto nicht erstellen:",
      pleaseLogin:
        "Fall Sie diese Email-Adresse zuvor verwendet haben, so <1>Loggen Sie sich bitte ein</1>",
    },
    selectAccountHolderTypeStep: {
      questionNewDepot: "Welche Art von Depot möchten Sie eröffnen?",
      questionAdvisorChange: "Um welche Art von Depot handelt es sich?",
      single: "Einzel-Depot",
      joined: "Gemeinschafts-Depot",
      minor: "Minderjährigen-Depot",
    },
    // Natural person
    summaryStep: {
      takeoverData: "Ja, Daten übernehmen",
      editData: "Nein, Daten bearbeiten",
    },
    personalInformationSummaryStep: {
      question: "Sind Ihre persönlichen Daten korrekt?",
      questionPartner: "Sind die persönlichen Daten Ihres Partners korrekt?",
      questionMinor: "Sind die persönlichen Daten des Minderjährigen korrekt?",
      questionLegalGuardian1:
        "Sind die persönlichen Daten des ersten Erziehungsberechtigten korrekt?",
      questionLegalGuardian2:
        "Sind die persönlichen Daten des zweiten Erziehungsberechtigten korrekt?",
      questionCompany: "Sind die Daten der Firma korrekt?",
      gender: "Geschlecht",
      firstName: "Vorname",
      lastName: "Nachname",
      nameAtBirth: "Geburtsname",
      dateOfBirth: "Geburtsdatum",
      placeOfBirth: "Geburtsort",
      countryOfBirth: "Geburtsland",
      street: "Straße",
      houseNumber: "Hausnummer",
      zip: "Postleitzahl",
      city: "Stadt",
      addressCountry: "Land",
    },
    companyInformationSummaryStep: {
      question: "Sind die Firmendaten korrekt?",
      salutation: "Anrede",
      companyName: "Firmenname",
      legalForm: "Rechtsform",
      street: "Straße",
      houseNumber: "Hausnummer",
      zip: "Postleitzahl",
      city: "Stadt",
      addressCountry: "Land",
    },
    payoutSummaryStep: {
      question: "Ist dieses Cashback-Auszahlungskonto korrekt?",
      bankNameWithBic: "Bank",
      iban: "IBAN",
      payoutAccountFirstName: "Vorname Inhaber",
      payoutAccountLastName: "Nachname Inhaber",
    },
    mifidSummaryStep: {
      question: "Sind Ihre MIFID Daten korrekt?",
      questionPartner: "Sind die MIFID Daten Ihres Partners korrekt?",
      questionMinor: "Sind die MIFID Daten des Minderjährigen korrekt?",
      questionLegalGuardian1:
        "Sind die MIFID Daten des ersten Erziehungsberechtigten korrekt?",
      questionLegalGuardian2:
        "Sind die MIFID Daten des zweiten Erziehungsberechtigten korrekt?",
      mifidOccupationGroup: "Berufsgruppe",
      mifidOccupation: "Beruf",
      mifidSector: "Branche",
      mifidCountryOfWork: "Tätigkeits-Land",
      mifidAccessToInsiderInfo: "Zugang zu Insider Informationen",
      yes: "Ja",
      no: "Nein",
      mifidAnnualIncome: "Jährliches Einkommen",
      mifidLiquidAssets: "Liquides Vermögen",
    },
    investmentExperienceSummaryStep: {
      question: "Sind die Angaben zur Investment-Erfahrung korrekt?",
      "0": "keine Angabe",
      "1": "weniger als ein Jahr",
      "2": "mehr als ein Jahr",
      "3": "mehr als zwei Jahre",
      experienceCertificatesAndOptionsWithLeverage:
        "Optionsscheine und Zertifikate mit Hebelwirkung",
      experienceCertificatesAndOptionsWithoutLeverage:
        "Zertifikate ohne Hebelwirkung",
      experienceDomesticBonds:
        "Festverzinsliche Wertpapiere inländischer Emittenten",
      experienceDomesticStocks: "Aktien inländischer Gesellschaften",
      experienceForeignCurrency: "Devisengeschäften (nicht auf Termin)",
      experienceForeignStocks: "Aktien ausländischer Gesellschaften",
      experienceFunds: "Investmentfonds (Anlagegesellschaft außerhalb der EU)",
      experienceOther:
        "Sonstige Termingeschäfte, Geschäften mit herausgeschobenem Erfüllungszeitpunkt und / oder Hebelwirkung",
      experienceForeignBonds:
        "Festverzinsliche Wertpapieren ausländischer Emittenten oder in Fremdwährung",
    },
    taxationSummaryStep: {
      question: "Sind Ihre steuerlichen Daten korrekt?",
      questionPartner: "Sind die steuerlichen Daten Ihres Partners korrekt?",
      questionMinor: "Sind die steuerlichen Daten des Minderjährigen korrekt?",
      questionLegalGuardian1:
        "Sind die steuerlichen Daten des ersten Erziehungsberechtigten korrekt?",
      questionLegalGuardian2:
        "Sind die steuerlichen Daten des zweiten Erziehungsberechtigten korrekt?",
      taxationCountry1: "Steuerlicher Wohnsitz",
      taxationNumber1: "Steuernummer",
      taxationCountry2: "Zusätzlicher steuerlicher Wohnsitz",
      taxationNumber2: "Zusätzliche Steuernummer",
      taxationCountry3: "Steuerlicher Wohnsitz",
      taxationNumber3: "Zusätzliche Steuernummer",
      taxationUsTaxLiability: "US-Steuerpflicht",
      taxationUsTaxNumber: "US Steuernummer",
      yes: "Ja",
      no: "Nein",
    },
    selectGenderStep: {
      question: "Sind sie...",
      questionPartner: "Ist Ihr Partner...",
      questionMinor: "Ist der Minderjährige...",
      questionLegalGuardian1: "Ist der erste Erziehungsberechtigte...",
      questionLegalGuardian2: "Ist der zweite Erziehungsberechtigte...",
      questionCompany: "Ihre Anrede...",
      male: "Männlich",
      female: "Weiblich",
      salutation: "Anrede",
    },
    hasSecondLegalGuardianStep: {
      question: "Gibt es einen zweiten Erziehungsberechtigten?",
      single: "Alleinerziehend",
      joined: "Zweiten Erziehungsberechtigten angeben",
    },
    firstNameStep: {
      question: "Ihr Vorname",
      questionPartner: "Vorname Partner",
      questionMinor: "Vorname des Minderjährigen",
      questionLegalGuardian1: "Vorname erster Erziehungsberechtigter",
      questionLegalGuardian2: "Vorname zweiter Erziehungsberechtigter",
      questionCompany: "Name der Firma",
      placeholder: "Vorname",
      companyPlaceholder: "Firmenname",
    },
    lastNameStep: {
      question: "Ihr Nachname",
      questionPartner: "Nachname Partner",
      questionMinor: "Nachname des Minderjährigen",
      questionLegalGuardian1: "Nachname erster Erziehungsberechtigter",
      questionLegalGuardian2: "Nachname zweiter Erziehungsberechtigter",
      questionCompany: "Rechtsform (GmbH / UG, ...)",
      placeholder: "Nachname",
      companyPlaceholder: "Rechtsform",
    },
    countryOfBirthStep: {
      question: "Ihr Geburtsland",
      questionPartner: "Geburtsland Partner",
      questionMinor: "Geburtsland des Minderjährigen",
      questionLegalGuardian1: "Geburtsland erster Erziehungsberechtigter",
      questionLegalGuardian2: "Geburtsland zweiter Erziehungsberechtigter",
      placeholder: "Bitte Land wählen",
    },
    placeOfBirthStep: {
      question: "Ihr Geburtsort",
      questionPartner: "Geburtsort Partner",
      questionMinor: "Geburtsort des Minderjährigen",
      questionLegalGuardian1: "Geburtsort erster Erziehungsberechtigter",
      questionLegalGuardian2: "Geburtsort zweiter Erziehungsberechtigter",
      placeholder: "Geburtsort",
    },
    nameAtBirthStep: {
      question: "Was ist Ihr Geburtsname?",
      questionPartner: "Was ist der Geburtsname Ihres Partners?",
      questionMinor: "Was ist der Geburtsname des Minderjährigen?",
      questionLegalGuardian1: "Geburtsname des ersten Erziehungsberechtigten",
      questionLegalGuardian2: "Geburtsname des zweiten Erziehungsberechtigten",
      placeholder: "Geburtsname",
    },
    dateOfBirthStep: {
      question: "Ihr Geburtsdatum",
      questionPartner: "Geburtsdatum Ihres Partners",
      questionMinor: "Geburtsdatum des Minderjährigen",
      questionLegalGuardian1: "Geburtsdatum des ersten Erziehungsberechtigten",
      questionLegalGuardian2: "Geburtsdatum des zweiten Erziehungsberechtigten",
      placeholder: "Geburtsdatum",
      label: "Geburtsdatum",
    },
    addressStep: {
      question: "Ihre Adresse: Straße",
      questionPartner: "Adresse Ihres Partners: Straße",
      questionMinor: "Adresse des Minderjährigen: Straße",
      questionLegalGuardian1: "Adresse erster Erziehungsberechtigter: Straße",
      questionLegalGuardian2: "Adresse zweiter Erziehungsberechtigter: Straße",
      questionCompany: "Firmenadresse: Straße",
      placeholder: "Straße",
      placeholderHouseNumber: "Hausnummer",
    },
    houseNumberStep: {
      placeholder: "Hausnummer",
    },
    zipStep: {
      question: "Ihre Adresse: Postleitzahl",
      questionPartner: "Adresse Ihres Partners: Postleitzahl",
      questionMinor: "Adresse des Minderjährigen: Postleitzahl",
      questionLegalGuardian1:
        "Adresse erster Erziehungsberechtigter: Postleitzahl",
      questionLegalGuardian2:
        "Adresse zweiter Erziehungsberechtigter: Postleitzahl",
      questionCompany: "Firmensitz: Postleitzahl",
      placeholder: "Postleitzahl",
    },
    cityStep: {
      question: "Ihre Adresse: Wohnort",
      questionPartner: "Adresse Ihres Partners: Wohnort",
      questionMinor: "Adresse des Minderjährigen: Wohnort",
      questionLegalGuardian1: "Adresse erster Erziehungsberechtigter: Wohnort",
      questionLegalGuardian2: "Adresse zweiter Erziehungsberechtigter: Wohnort",
      questionCompany: "Firmensitz: Ort",
      placeholder: "Wohnort",
    },
    addressCountryStep: {
      question: "Ihre Adresse: Land",
      questionPartner: "Adresse Ihres Partners: Land",
      questionMinor: "Adresse des Minderjährigen: Land",
      questionLegalGuardian1: "Adresse erster Erziehungsberechtigter: Land",
      questionLegalGuardian2: "Adresse zweiter Erziehungsberechtigter: Land",
      questionCompany: "Firmensitz: Land",
      placeholder: "Land",
    },
    occupationalGroupStep: {
      question: "In welcher Berufsgruppe sind Sie tätig",
      questionPartner: "In welcher Berufsgruppe ist Ihr Partner tätig?",
      questionMinor: "In welcher Berufsgruppe ist der Minderjährige tätig?",
      questionLegalGuardian1:
        "In welcher Berufsgruppe ist der erste Erziehungsberechtigte tätig?",
      questionLegalGuardian2:
        "In welcher Berufsgruppe ist der zweite Erziehungsberechtigte tätig?",
      placeholder: "Berufsgruppe",
    },
    occupationStep: {
      question: "Welchen Beruf üben Sie aus",
      questionPartner: "Welchen Beruf übt Ihr Partner aus?",
      questionMinor: "Welchen Beruf übt der Minderjährige aus?",
      questionLegalGuardian1:
        "Welchen Beruf übt der erste Erziehungsberechtigte aus?",
      questionLegalGuardian2:
        "Welchen Beruf übt der zweite Erziehungsberechtigte aus?",
      placeholder: "Beruf",
    },
    sectorStep: {
      question: "In welcher Branche sind Sie tätig",
      questionPartner: "In welcher Branche ist Ihr Partner tätig?",
      questionMinor: "In welcher Branche ist der Minderjährige tätig?",
      questionLegalGuardian1:
        "In welcher Branche ist der erste Erziehungsberechtigte tätig?",
      questionLegalGuardian2:
        "In welcher Branche ist der zweite Erziehungsberechtigte tätig?",
      placeholder: "Branche",
    },
    countryOfWorkStep: {
      question: "In welchem Land arbeiten Sie?",
      questionPartner: "In welchem Land arbeitet Ihr Partner?",
      questionMinor: "In welchem Land arbeitet der Minderjährige?",
      questionLegalGuardian1:
        "In welchem Land arbeitet der erste Erziehungsberechtigte?",
      questionLegalGuardian2:
        "In welchem Land arbeitet der zweite Erziehungsberechtigte?",
      placeholder: "Land wählen",
    },
    accessToInsiderInfoStep: {
      question: "Haben Sie Zugang zu Insider-Informationen?",
      questionPartner: "Hat Ihr Partner Zugang zu Insider-Informationen?",
      questionMinor: "Hat der Minderjährige Zugang zu Insider-Informationen?",
      questionLegalGuardian1:
        "Hat der erste Erziehungsberechtigte Zugang zu Insider-Informationen?",
      questionLegalGuardian2:
        "Hat der zweite Erziehungsberechtigte Zugang zu Insider-Informationen?",
      yes: "Ja",
      no: "Nein",
    },
    annualIncomeStep: {
      question: "Jährliches Einkommen (Optional)",
      questionPartner: "Jährliches Einkommen Partner (Optional)",
      questionMinor: "Jährliches Einkommen des Minderjährigen (Optional)",
      questionLegalGuardian1:
        "Jährliches Einkommen erster Erziehungsberechtigter (Optional)",
      questionLegalGuardian2:
        "Jährliches Einkommen zweiter Erziehungsberechtigter (Optional)",
      placeholder: "Jährliches Einkommen",
    },
    liquidAssetsStep: {
      question: "Liquides Vermögen (Optional)",
      questionPartner: "Liquides Vermögen Partner (Optional)",
      questionMinor: "Liquides Vermögen des Minderjährigen (Optional)",
      questionLegalGuardian1:
        "Liquides Vermögen erster Erziehungsberechtigter (Optional)",
      questionLegalGuardian2:
        "Liquides Vermögen zweiter Erziehungsberechtigter (Optional)",
      placeholder: "Liquides Vermögen",
    },
    countryOfNationalityStep: {
      questionPrimary: "Ihre Staatsangehörigkeit",
      questionSecondary: "Weitere Staatsangehörigkeit",
      questionPartnerPrimary: "Staatsangehörigkeit Partner",
      questionPartnerSecondary: "Weitere Staatsangehörigkeit Partner",
      questionMinorPrimary: "Staatsangehörigkeit des Minderjährigen",
      questionMinorSecondary: "Weitere Staatsangehörigkeit des Minderjährigen",
      questionLegalGuardian1Primary:
        "Staatsangehörigkeit erster Erziehungsberechtigter",
      questionLegalGuardian1Secondary:
        "Weitere Staatsangehörigkeit erster Erziehungsberechtigter",
      questionLegalGuardian2Primary:
        "Staatsangehörigkeit zweiter Erziehungsberechtigter",
      questionLegalGuardian2Secondary:
        "Weitere Staatsangehörigkeit zweiter Erziehungsberechtigter",
      placeholder: "Land wählen",
    },
    anotherNationalityStep: {
      question: "Sind Sie Inhaber einer weiteren Staatsangehörigkeit?",
      questionPartner:
        "Ist Ihr Partner Inhaber einer weiteren Staatsangehörigkeit?",
      questionMinor:
        "Ist der Minderjährige Inhaber einer weiteren Staatsangehörigkeit?",
      questionLegalGuardian1:
        "Ist der erste Erziehungsberechtigte Inhaber einer weiteren Staatsangehörigkeit?",
      questionLegalGuardian2:
        "Ist der zweite Erziehungsberechtigte Inhaber einer weiteren Staatsangehörigkeit?",
      yes: "Ja",
      no: "Nein",
    },
    npNationalIdentifierStep: {
      questionPrimary: "Ihre nationale Kennung",
      questionSecondary: "Ihre nationale Kennung (zweite Staatsangehörigkeit)",
      questionPartnerPrimary: "Nationale Kennung Partner",
      questionPartnerSecondary:
        "Nationale Kennung Partner (zweite Staatsangehörigkeit)",
      questionMinorPrimary: "Nationale Kennung Minderjähriger",
      questionMinorSecondary:
        "Nationale Kennung Minderjähriger (zweite Staatsangehörigkeit)",
      questionLegalGuardian1Primary:
        "Nationale Kennung erster Erziehungsberechtigter",
      questionLegalGuardian1Secondary:
        "Nationale Kennung erster Erziehungsberechtigter (zweite Staatsangehörigkeit)",
      questionLegalGuardian2Primary:
        "Nationale Kennung zweiter Erziehungsberechtigter",
      questionLegalGuardian2Secondary:
        "Nationale Kennung zweiter Erziehungsberechtigter (zweite Staatsangehörigkeit)",
      placeholder: "Nationale Kennung",
    },
    countryOfTaxationStep: {
      question: "Ihr steuerlicher Wohnsitz",
      questionPartner: "Steuerlicher Wohnsitz Partner",
      questionMinor: "Steuerlicher Wohnsitz Minderjähriger",
      questionLegalGuardian1:
        "Steuerlicher Wohnsitz erster Erziehungsberechtigter",
      questionLegalGuardian2:
        "Steuerlicher Wohnsitz zweiter Erziehungsberechtigter",
      placeholder: "Land wählen",
    },
    taxNumberStep: {
      question: "Ihre Steuernummer",
      questionPartner: "Steuernummer Partner",
      questionMinor: "Steuernummer des Minderjährigen",
      questionLegalGuardian1: "Steuernummer erster Erziehungsberechtigter",
      questionLegalGuardian2: "Steuernummer zweiter Erziehungsberechtigter",
      placeholder: "Steuernummer",
    },
    usTaxLiabilityStep: {
      question: "Unterliegen Sie der US Steuerpflicht?",
      questionPartner: "Unterliegt Ihr Partner der US Steuerpflicht?",
      questionMinor: "Unterliegt der Minderjährige der US Steuerpflicht?",
      questionLegalGuardian1:
        "Unterliegt der erste Erziehungsberechtigte der US Steuerpflicht?",
      questionLegalGuardian2:
        "Unterliegt der zweite Erziehungsberechtigte der US Steuerpflicht?",
      yes: "Ja",
      no: "Nein",
    },
    npTaxationOneMoreStep: {
      question: "Sind Sie in einem weiteren Land steuerpflichtig?",
      questionPartner:
        "Ist Ihr Partner in einem weiteren Land steuerpflichtig?",
      questionMinor:
        "Ist der Minderjährige in einem weiteren Land steuerpflichtig?",
      questionLegalGuardian1:
        "Ist der erste Erziehungsberechtigte in einem weiteren Land steuerpflichtig?",
      questionLegalGuardian2:
        "Ist der zweite Erziehungsberechtigte in einem weiteren Land steuerpflichtig?",
      yes: "Ja",
      no: "Nein",
    },
    investmentExperienceStep: {
      pleaseSelectOption: "Bitte wählen...",
      lessThanYearOption: "Weniger als ein Jahr",
      moreThanYearOption: "Mehr als ein Jahr",
      moreThanTwoYearsOption: "Mehr als zwei Jahre",
    },
    experienceCertificatesAndOptionsWithLeverageStep: {
      question:
        "Ihre Erfahrung mit Optionsscheinen und Zertifikaten mit Hebelwirkung",
    },
    experienceCertificatesAndOptionsWithoutLeverageStep: {
      question: "Ihre Erfahrung mit Zertifikaten ohne Hebelwirkung",
    },
    experienceDomesticBondsStep: {
      question:
        "Ihre Erfahrung mit festverzinslichen Wertpapieren inländischer Emittenten",
    },
    experienceDomesticStocksStep: {
      question: "Ihre Erfahrung mit Aktien inländischer Gesellschaften",
    },
    experienceForeignCurrencyStep: {
      question: "Ihre Erfahrung mit Devisengeschäften (nicht auf Termin)",
    },
    experienceForeignStocksStep: {
      question: "Ihre Erfahrung mit Aktien ausländischer Gesellschaften",
    },
    experienceFundsStep: {
      question:
        "Ihre Erfahrung mit Investmentfonds (Anlagegesellschaft außerhalb der EU)",
    },
    experienceOtherStep: {
      question:
        "Ihre Erfahrung mit sonstigen Termingeschäften, Geschäften mit herausgeschobenem Erfüllungszeitpunkt und / oder Hebelwirkung",
    },
    experienceForeignBondsStep: {
      question:
        "Ihre Erfahrung mit festverzinslichen Wertpapieren ausländischer Emittenten oder in Fremdwährung",
    },
    comdirectConditionModelStep: {
      question: "Welches Konditionsmodell bevorzugen Sie?",
      subtitle: "Hinweis: Sie können Ihr Konditionsmodell jederzeit anpassen.",
      conditionModel3: 'Modell "Flatfee"',
      conditionModel3Description:
        "Das Modell für große Depots <1>ab 8.000 € Volumen</1> <2> pro Order</2>",
      conditionModel3DescriptionDetails:
        "Dieses Konditionsmodell beinhaltet eine pauschale Transaktionsgebühr der Bank (Flatfee) von 19,95 € für Börsengeschäfte - unabhängig von der Ordergröße.",
      conditionModel5: 'Modell "Standard"',
      conditionModel5Description:
        "Das Standardmodell; für Depots mit <1>bis zu 8.000 € Volumen</1> <2>pro Order</2>",
      conditionModel5DescriptionDetails:
        "Dieses Konditionsmodell beinhaltet eine prozentuale Transaktionsgebühr von 0,25% des Ordervolumens, jedoch mind. 10,00 € und max. 90,00 €",
    },
    dabConditionModelStep: {
      question: "Welches Konditionsmodell bevorzugen Sie?",
      subtitle: "Hinweis: Sie können Ihr Konditionsmodell jederzeit anpassen.",
      conditionModel1228: 'Modell "Flatfee"',
      conditionModel1228Description:
        "Das Modell für große Depots <1>ab 6.000 € Volumen</1> <2> pro Order</2>",
      conditionModel1228DescriptionDetails:
        "Dieses Konditionsmodell beinhaltet eine pauschale Transaktionsgebühr von 15,00 € (plus evtl. Courtage) für Börsengeschäfte und Festpreisgeschäfte - unabhängig von der Ordergröße.",
      conditionModel1139: 'Modell "Standard"',
      conditionModel1139Description:
        "Das Standardmodell; für Depots mit <1>bis zu 6.000 € Volumen</1> <2>pro Order</2>",
      conditionModel1139DescriptionDetails:
        "Dieses Konditionsmodell beinhaltet eine prozentuale Transaktionsgebühr von 0,25% des Ordervolumens, jedoch mind. 10,00 € und max. 75,00 €",
    },
    dwsDepotTypeStep: {
      question:
        "Für welche DWS Produkte möchten Sie von {{appName}} Cashback profitieren?",
      fundDepot: "Mein DWS Fondsdepot",
      retirementPlan: "Meine DWS Altersvorsorge (Riester / Rürup / Basisrente)",
    },
    payoutIbanStep: {
      question: "Wohin soll Ihr Cashback überwiesen werden?",
      placeholder: "IBAN",
    },
    payoutAccountHolderLastNameStep: {
      question: "Nachname des Kontoinhabers (Cashback-Auszahlungskonto)",
      placeholder: "Nachname",
    },
    payoutAccountHolderFirstNameStep: {
      question: "Vorname des Kontoinhabers (Cashback-Auszahlungskonto)",
      placeholder: "Vorname",
    },
    promotionCodeStep: {
      question: "Haben Sie einen Gutschein oder Empfehlungscode?",
      placeholder: "Gutschein / Empfehlungscode",
      validationSuccess: "Rabatt",
    },
    phoneNumberStep: {
      question:
        "Unter welcher Telefonnummer können wir Sie bei Rückfragen erreichen?",
      placeholder: "Telefonnummer",
    },
    usTaxNumberStep: {
      question: "Wie lautet Ihre US-TIN/-SSN?",
      questionPartner: "Wie lautet die US-TIN/-SSN Ihres Partners?",
      questionMinor: "Wie lautet die US-TIN/-SSN des Minderjährigen?",
      questionLegalGuardian1:
        "Wie lautet die US-TIN/-SSN des ersten Erziehungsberechtigten?",
      questionLegalGuardian2:
        "Wie lautet die US-TIN/-SSN des zweiten Erziehungsberechtigten?",
      placeholder: "US-TIN/-SSN",
    },
    dabMobileForTanStep: {
      question: "An welche Mobilfunk-Nummer soll die DAB Ihre TAN senden?",
      placeholder: "Mobilfunk-Nummer",
    },
    fondsdepotSelectDepotTypeStep: {
      question: "Möchten Sie ein Standard-Depot oder ein VL Depot eröffnen?",
      normal: "Standard-Depot",
      vl: "VL-Depot",
    },
    accountIdentifierStep: {
      question: "Nummer Ihres bestehenden Depots",
      questions: {
        COBADEHDXXX: "Ihre comdirect Kundennummer",
        DABBDEMMXXX: "Ihre DAB Konto-Stammnummer",
      },
      placeholders: {
        AUGBDE77XXX: "10 Ziffern (0-9)",
        COBADEHDXXX: "10 Ziffern (0-9)",
        DABBDEMMXXX: "7 Ziffern (0-9)",
        DEUTDEFFXXX: "1 Buchstabe, gefolgt von 7 Ziffern",
        COBADEMXXXX: "10 oder 11 Ziffern (0-9)",
        FFBKDEFFTHK: "10 Ziffern (0-9)",
        FODBDE77XXX: "10 Ziffern (0-9)",
        METZDEFFXXX: "10 Ziffern (0-9)",
      },
      accountIdentifierIsUsedMessage:
        "Diese Depot bzw. Kundennummer wurde bereits in einer anderen Buchung verwendet.",
    },
    comdirectCustomerHelpStep: {
      helpText: "Wo finde ich meine Kundennummer?",
      question: "Wo finde ich meine comdirect Kundennummer?",
      description:
        'Sie finden Ihre Kundennummer im "Persönlichen Bereich" unter dem Menüpunkt "Verwaltung" -> "Meine Daten".',
    },
    startDateStep: {
      question: "Datum des Betreuerwechsels",
      label: "Datum Betreuerwechsel",
    },
    selectAccountHolderStep: {
      question: "Kontoinhaber wählen",
      subheading:
        "Jeder Kontoinhaber kann kostenlos beliebig viele eigene oder Gemeinschaftsdepots verwalten. {{appName}} erhält maximal 15 € / Monat pro Kontoinhaber.",
      onvistaSubheading:
        "Jeder Kontoinhaber kann kostenlos beliebig viele eigene oder Gemeinschaftsdepots verwalten.",
      orAddNew: "oder",
      newAccountHolder: "Neuen Kontoinhaber erstellen",
      newAccountHolderNote:
        "{{appName}} rechnet pro Kontoinhaber ab. Wenn Sie hier klicken, erstellen Sie einen neuen Kontoinhaber, welcher separat abgerechnet wird. Verwenden Sie diese Funktion z.B. für Partner oder Ihre Kinder.",
      onvistaNewAccountHolderNote:
        "Die Abrechnung und Auszahlung erfolgt pro Kontoinhaber. Wenn Sie hier klicken, erstellen Sie einen neuen Kontoinhaber, welcher separat abgerechnet und ausgezahlt wird. Verwenden Sie diese Funktion z.B. für Partner oder Ihre Kinder.",
    },
    // BREAKPOINT FOR GENERATORS DO NOT REMOVE
    helpStep: {
      close: "Schließen",
    },
    nextButton: {
      next: "Weiter",
      skip: "Überspringen",
    },
    orEnter: "oder EINGABE drücken",
    header: {
      phone: {
        title: "Fragen?",
      },
    },
    userCreatedNotification:
      "Ihr Benutzer-Account wurde bereits erstellt. Daher ist eine Änderung nicht mehr möglich.",
  },
  banks: {
    COBADEHDXXX: "comdirect",
    DABBDEMMXXX: "DAB BNP Paribas",
    AUGBDE77XXX: "Augsburger Aktienbank",
    DEUTDEFFXXX: "DWS",
    DEUTLU2DXXX: "MorgenFund",
    COBADEMXXXX: "FNZ",
    FFBKDEFFTHK: "FIL Fondsbank (FFB)",
    FODBDE77XXX: "Fondsdepot Bank",
    METZDEFFXXX: "Metzler (MFX)",
  },
  countryAutocomplete: {
    mostUsed: "Häufig verwendet",
    others: "Weitere",
  },
  bankFacts: {
    rating: {
      description: "Unsere Bewertung",
    },
    allBanksLink: "zum Vergleich aller Banken",
    comdirect: {
      depotFee: "0 € Depotführung",
      numberOfFunds: "über 23.000 handelbare Fonds",
      fundSavingsPlan: "0,95 € Kosten für Fondssparplan",
      allInOne: "Fonds, Aktien und ETF handeln",
    },
  },
  cashbackCalculator: {
    cashback: {
      "50": "Cashback-50",
      "100": "Cashback-100",
    },
    detailed: {
      cashbackAreaChart: {
        rentabloFee: "{{appName}} erhält max. {{fee}} monatlich",
        rentabloFeeXs: "Max. {{fee}} für {{appName}}",
        rentabloFeeCB50: "Für {{appName}}",
        cashbackLabel: "Ihr Fonds-Cashback",
        depotVolume: "Depotvolumen",
        portfolioCommission: "Bestandsprovision",
        fee: "Für {{appName}}",
        yourCashback: "Ihr Cashback",
        perMonth: "monatlich",
      },
      inputSlider: {
        label: "Ihr Vermögen",
      },
    },
  },
  products: {
    free: {
      subheader: "Basis Funktionen mit {{appName}}-Konto",
      features: [
        "1 Bankverbindung",
        "3 Jahre Historische Daten",
        "Support nur über das Nutzerforum",
      ],
    },
    plus: {
      subheader: "für Investoren im Vermögensaufbau",
      features: [
        "alle <strong>Basis-Funktionen inklusive</strong>",
        "<strong>5</strong> Bankverbindungen",
        "<strong>6 Jahre</strong> Historische Daten",
        "E-Mail Support innerhalb von 5 Tagen",
        "Umsatzlisten hochladen",
        "Crypto",
        "Dividenden",
      ],
    },
    pro: {
      subheader:
        "für Investoren, die ihr Vermögen selbst professionell verwalten",
      features: [
        "alle <strong>PLUS Funktionen inklusive</strong>",
        "<strong>unbegrenzt</strong> viele Bankverbindungen",
        "<strong>10 Jahre</strong> Historische Daten",
        "<strong>Telefon-Support</strong>,",
        "<strong>unbegrenzt</strong> Umsatzlisten hochladen",
        "Data Enrichment",
        "Reports and Export-optionen",
        "Simulatoren",
      ],
    },
  },
  fundamentals: {
    topHoldings: "Top 10 Holdings",
    chartMenu: {
      hide: "Ausblenden",
    },
    metrics: {
      dividendsPerYear: {
        normal: "Dividenden-Entwicklung",
        short: "Dividenden",
        desc: "Die Dividenden Auszahlungs-Historie. Erfolgen mehrere Zahlungen pro Jahr, so werden die Werte auf volle Jahre aufsummiert.",
      },
    },
    dividends: {
      kpi: {
        latestDividend: "Letzte Dividende ({{year}})",
        averageAndSum: "Ø jährlich · Summe ({{count}} J.)",
      },
    },
    detailInformation: {
      title: "Detail-Informationen",
      marketCap: "Marktkapitalisierung",
      indexes: "Indizes",
      sector: "Branche",
      lastUpdate: "Letztes Bilanz-Update",
      country: "Land",
    },
    year_one: "{{count}} Jahr",
    year_other: "{{count}} Jahre",
    ranksAndRisks: {
      fwwFundStars: "FWW FundStars®",
      fwwFundStarsInfo:
        "Die FWW FundStars® basieren auf der Risikoadjustierten Performance (RAP). Diese zweidimensionale Kennzahl errechnet sich aus der erzielten Wertentwicklung (Performance) und dem dabei eingegangenen Risiko (Volatilität). Für die FWW FundStars® werden die Fonds in 5 Ranking-Stufen à 20 Prozent klassifiziert, aus denen die Auszeichnung mit 5 bis 1 Sternen hervorgeht. Dabei erhalten die besten 20 Prozent der Fonds fünf Sterne.",
      srri: "SRRI",
      srriInfo:
        "Der Synthetic Risk and Reward Indicator (SRRI) bezeichnet den synthetischen Risiko- und Ertragsindikator. Der SRRI ist eine Kennzahl für die Höhe der mit der Veranlagung in einem Fonds verbundenen Wertschwankungen. Der SRRI wird mit einer EU-weit einheitlichen Methodik ermittelt und kann die Werte 1 bis 7 annehmen, wobei höhere Werte für höhere Wertschwankungen stehen. In der Regel sind mit höheren Wertschwankungen auch höhere Renditechancen verbunden. Ein SRRI von 1 bedeutet aber nicht, dass es sich um eine risikofreie Anlage handelt.",
      title: "Ratings und Risiken",
    },
  },

  investment: {
    isinMissing: {
      title: "Fehlende ISIN",
      subtitle:
        "Für dieses Wertpapier liegt derzeit keine gültige ISIN vor. Bitte ergänzen Sie die ISIN in den erweiterten Einstellungen.",
    },
    title: "Wertpapier",
    header: {
      chart: {
        subheader: "Aktueller Kurs",
      },
      actions: {
        addBookingButton: "Buchung hinzufügen",
        moreButton: "Mehr",
        editInvestmentButton: "Investment bearbeiten",
        deleteInvestmentButton: "Investment löschen",
      },
      deleteModal: {
        question: "Dieses Investment löschen?",
        success: "Investment erfolgreich gelöscht",
      },
    },
    details: {
      gainLossStatistics: {
        title: "Meine Wertentwicklung",
        gainAndLoss: "GuV (Entwicklung + Realisiert)",
        returnOnInvestment: "Kursgewinne",
        realizedGains: "Realisierte Gewinne",
        irr: "Rendite (IRR) p. a. über {{years}} Jahre",
        twror: "Performance",
        purchasePrice: "Erwerbspreis",
        investedAmount: "Investierter Betrag",
        marketValue: "Marktwert",
        tradingGains: "Handelsgewinne",
        dividends: "Dividenden",
        commission: "Kommission",
        tax: "Steuern",
        fromMarketReturns: "aus Kursgewinnen",
        fromMarketAndCurrencyReturns: "aus Kurs- und Währungsgewinnen",
        fromDividendsAndKupons: "aus Dividenden/Kupons",
      },
    },
    performance: "Wertentwicklung",
    tabs: {
      fundamentals: "Fundamentaldaten",
      dividends: "Dividenden",
      protocol: "Protokoll",
    },
    protocolTable: {
      bookingType: "Typ",
      overallValue: "Gesamtwert",
      period: "Zeitraum",
      amount: "Kurs",
      expenses: "Kosten",
      totalSum: "Summe",
      noBookings: "Keine Buchungen im Zeitraum",
      comment: "Kommentar",
      cancelled: "Storniert",
      gainersAndLosersLabel: "GuV",
      actions: {
        title: "Aktion",
        addBooking: "Buchung hinzufügen",
        edit: "Bearbeiten",
        delete: "Löschen",
      },
      deleteDialog: {
        title: "Buchung löschen",
        questionMessage: "Möchten Sie diese Buchung wirklich löschen?",
        actions: {
          close: "Schließen",
          delete: "Löschen",
        },
      },
    },
    dividends: {
      noDividends: "Keine Dividenden. Möchten Sie einen Eintrag hinzufügen?",
      noDividendsAddLink: "Hinzufügen",
      addDividends: "Manueller Eintrag",
      splitAdjust: "Splitbereinigt",
      missingDividends: {
        header_one: "{{value}} fehlende Dividende.",
        header_other: "{{value}} fehlende Dividenden.",
        addBatchButton: "Jetzt hinzufügen",
      },
      dividendsTableHeaders: {
        date: "Datum",
        dividend: "Dividende",
        lots: "Stück",
        total: "Gesamt",
        actions: "Optionen",
      },
      tableActions: {
        addDividends: "Hinzufügen",
        editDividends: "Bearbeiten",
      },
    },
    recommendation: {
      title: "Produktvorschläge",
      description:
        "Wir haben Produkte gefunden, die besser zu Ihrem Portfolio und Ihren Präferenzen passen. Mit der Checkbox kann das Produkt zum Chart hinzugefügt werden.",
      showAll: "Alle Vorschläge ansehen",
    },
  },
  singleAccountPage: {
    breadcrumbs: {
      home: "Home",
      accounts: "Konten",
    },
    header: {
      account: "Konto",
      update: "Aktualisieren",
      addTransaction: "Transaktion hinzufügen",
      edit: "Bearbeiten",
      manageBankConnection: "Bankverbindung verwalten",
      hide: "Permanent Ausblenden",
      show: "Zeigen",
      delete: "Konto löschen",
      deleteModal: {
        question: "Dieses Konto löschen?",
      },
    },
    protocolTable: {
      title: "Transaktionen",
      headers: {
        valueDate: "Valuta",
        bookingDate: "Buchtag",
        bookingInformation: "Buchungsinformation",
        value: "Wert",
      },
      search: {
        placeholder: "Suche",
      },
      noPurpose: "Nicht verfügbar",
      noItems: "Keine Transaktionen für den Zeitraum",
      export: "Export CSV",
      transfer: "Kontentransfer",
      adjustingEntry: "Ausgleichsbuchung",
      adjustingEntryText:
        "Sollte der Kontostand durch einen Kauf unter Null fallen, so wird dieser automatisch ausgeglichen.",
      interval: {
        everyMonth: "Jeden Monat",
        biMonthly: "Alle 2 Monate",
        quarterly: "Quartalsweise",
        biAnnual: "Halbjährlich",
        annual: "Jährlich",
      },
    },
  },
  addManuallyPage: {
    addManuallyBreadcrumb: "Von Hand hinzufügen",
    header: {
      title: "Cash-Transaktion",
      subtitle: "Neue Cash-Transaktion erstellen",
    },
    form: {
      additionalInformation: {
        summary: "Weitere Informationen",
        interestTitle: "Zinsen / Gebühren:",
        interestBody:
          "Zinsen oder Gebühren wie z.B. Depotführungsgebühren. Sollzinsen und Gebühren haben ein negatives, Habenzinsen ein positives Vorzeichen.",
        otherGainsTitle: "Sonstige Gewinne:",
        otherGainsBody:
          "Gewinne aus (nicht verbuchten) Wertpapier-Transaktionen. Dies könnte z.B. eine Rückerstattung oder ein anderweitiger Gewinn sein.",
        taxRefundTitle: "Steuern/Rückerst.:",
        taxRefundBody:
          "Gezahlte Steuern oder erhaltene Steuerrückerstattungen. Gezahlte Steuern haben ein negatives, erhaltene Rückerstattungen ein positives Vorzeichen.",
      },
      type: "Art der Transaktion:",
      types: {
        withdrawal: "Abhebung",
        deposit: "Einzahlung",
        interest: "Zinsen / Gebühren",
        tax_refund: "Steuern / Rückerstattung",
        other_gains: "Sonstige Gewinne",
      },
      netAmount: "Nettobetrag:",
      taxAmount: "Steuern:",
      totalAmount: "Bruttobetrag:",
      date: "Eingezahlt am:",
      datepickerCancelButton: "Abbrechen",
      purpose: "Kommentar:",
      hints: {
        other_gains:
          "Sonstige Gewinne können starken Einfluss auf die Performance haben. Bitte markieren Sie diese Transaktion nur als Sonstige Gewinne wenn diese auch tatsächlich ein Handelsgewinn, eine Steuerrückerstattung o.Ä. war.",
      },
      submit: "Speichern",
      messages: {
        success: "Erfolgreich gespeichert",
      },
    },
  },
  createAndEditAccount: {
    editBreadcumb: "Bearbeiten",
    header: {
      title: "Bearbeiten: {{value}}",
    },
    actions: {
      save: "Speichern",
      delete: "Löschen",
      deleteAllInvestments: "Alle Investments löschen",
      deleteAllCashTransactions:
        "Sie können auch alle Bargeldtransaktionen löschen",
    },
    deleteDialog: {
      titleInvestments: "Alle Investments löschen",
      titleAllCashTransactions: "Alle Cash-Transaktionen löschen",
      questionInvestments: "Möchten Sie wirklich alle Investments löschen?",
      questionCashTransaction:
        "Möchten Sie wirklich alle Cash-Transaktionen löschen?",
      close: "Abbrechen",
      delete: "Löschen",
    },
  },
  watchlistEntry: {
    details: {
      gainLossStatistics: {
        title: "Wertentwicklung",
        gainAndLoss: "Kursentwicklung",
        entryQuote: "Einstandskurs",
        currentQuote: "Aktueller Kurs",
        historicReturns: "Historische Performance",
      },
    },
  },
  depotTransfer: {
    title: "Depotübertrag",
    header: {
      backButton: "Zurück",
      title: "Depotübertrag",
    },
    selectTransferTypeStep: {
      question:
        "Wollen Sie das gesamte Depot oder einzelne Positionen übertragen?",
      full: "Gesamtes Depot",
      partial: "Ausgewählte Positionen",
    },
    depotAutocompleteStep: {
      question: "Zu welchem Depot möchten Sie übertragen?",
      placeholder: "Depot wählen",
    },
    dateOfTransferStep: {
      question: "Wann fand der Depotübertrag statt?",
      label: "Datum",
    },
    investmentsTable: {
      investments: "Positionen",
      totalNumberOfLots: "Anzahl",
      transferNumberOfLots: "Stück Übertrag",
    },
    validation: {
      destinationAccountIdIsEmpty: "Zieldepot muss gewählt werden",
      investmentsToTransferIsEmpty:
        "Bitte wählen Sie mindestens eine Position aus",
      investmentsToTransferIsIncorrect:
        "Ungültige Stückzahl für einige Positionen",
      numberOfLotsCanNotBeLessThanZero: "darf nicht negativ sein",
      numberOfLotsCanNotBeMoreThanOriginal:
        "darf nicht größer als verfügbare Stückzahl sein",
      dateOfTransferCanNotBeInFuture:
        "Übertrags-Datum darf nicht in der Zukunft liegen",
      dateOfTransferCanNotBeEmpty: "Übertrags-Datum darf nicht leer sein",
    },
    successStep: {
      message: "Positionen wurden erfolgreich übertragen",
      finishButton: "Zurück zum Depot",
    },
    fullLotsStep: {
      question:
        "Überträgt Ihre Bank die gesamte Position oder nur volle Stücke?",
      onlyFullLots: "Nur volle Stücke",
      fullLotsAndPartials: "Die gesamte Position",
    },
    selectInvestmentsStep: {
      question: "Welche Positionen möchten Sie übertragen?",
      noInvestments: "Keine Positionen im gewählten Depot",
    },
  },
  bankConnections: {
    success: {
      message: "Import erfolgreich abgeschlossen",
      toDepots: "Zur Depotübersicht",
    },
    legalNote: {
      pageTitle: "Depots/Konten importieren",
      title: "Bevor wir starten...",
      poweredBy: "Powered by wealthAPI",
      finApi:
        "wealthAPI gewährleistet Ihnen sicheren Zugriff auf Ihre Bankdaten. Hierzu arbeiten wir mit finAPI, einem etablierten Anbieter dem auch Banken wie die DKB oder ING vertrauen, zusammen.",
      dataProtection:
        "wealthAPI behandelt Ihre Daten absolut vertraulich. Eine Weitergabe an Dritte erfolgt nicht.",
      next: "Akzeptieren und weiter",
    },
  },
  selectContraAccount: {
    accountTypeFromBank: {
      CHECKING: "Girokonto",
      SAVINGS: "Sparkonto",
      CREDIT_CARD: "Kreditkarte",
      DEPOT: "Depot",
      LOAN: "Kredit",
      MEMBERSHIP: "Mitgliedskonto",
      HOME_PURCHASE_SAVINGS: "Bausparkonto",
      REFERENCE_ACCOUNT: "Referenzkonto",
      FOREIGN_CURRENCY_ACCOUNT: "Fremdwährungskonto",
    },
    title: "Verrechnungskonto wählen",
    nextButton: "Weiter",
    depotIndex: "{{index}} von {{total}}",
    noAccount: "Ohne Verrechnungskonto",
    noAccountWarning:
      "Ohne Verrechnungskonto nur eingeschränkte Funktionalität! Keine Übernahme von Dividenden und exakten Daten aus Transkationen",
    showAllAccounts: "Alle Bankkonten anzeigen",
    showAccountsForSameBank: "Nur Konten bei Bank anzeigen",
  },
  assignContraAccount: {
    title: "Verrechnungskonto zuweisen",
  },
  synchronizationLog: {
    title: "Letzte Aktualisierungen",
    noUpdateRequired: "Positionen sind aktuell",
    new: "NEU",
    rollback: "Änderungen verwerfen",
    rolledBack: "VERWORFEN",
    checkRequired: "PRÜFEN",
  },
  depotsSelector: {
    allDepots: "Alle Depots",
    amountDepots: "{{ selected }} von {{ total }} Depots",
    noDepots: "Keine Depots",
    allAccounts: "Alle Konten",
    amountAccounts: "{{ selected }} von {{ total }} Konten",
    noAccounts: "Keine Konten",
    allPortfolios: "Alle Portfolios",
    amountPortfolios: "{{ selected }} von {{ total }} Portfolios",
    noPortfolios: "Keine Portfolios",
  },
  regionSelector: {
    label: "Region wählen",
  },
  industrySelector: {
    label: "Branche wählen",
  },
  tagSelector: {
    label: "Tag eingeben",
    addNewOption: 'Tag "{{name}}" erstellen',
  },
  classifications: {
    title: "Analyze",
    breadcrumbs: {
      home: "Home",
      classifications: "Depot-Klassifizierung",
    },
    tabs: {
      investments: "Investments",
      investmentType: "Assetklassen",
      region: "Regionen",
      industry: "Branchen",
      risk: "Volatilität",
      currency: "Währungen",
      yield: "Renditen",
      tag: "Eigene Gruppierungen",
    },
    empty: {
      title: "Keine Daten für diese Ansicht",
    },
    assignTagToInvestment: "Tag der Investition zuweisen",
    assignIndustryToInvestment: "Branche der Investition zuweisen",
    assignRegionToInvestment: "Region der Investition zuweisen",
    risk: {
      title: "Investments nach Risiko",
      tooltip:
        'Hoch: Das Risiko von Wertpapieren wird als "hoch" eingestuft, wenn die Volatilität  über 25 Prozent beträgt.<br/><br/>Moderat: Das Risiko von Wertpapieren wird als "moderat" eingestuft, wenn die Volatilität zwischen 15 und 25 Prozent beträgt.<br/><br/>Gering: Das Risiko von Wertpapieren wird als "gering" eingestuft, wenn die Volatilität unter 15 Prozent beträgt.',
      unclassified: "Nicht klassifiziert",
      numberToWord: {
        "0": "Gering",
        "1": "Moderat",
        "2": "Hoch",
      },
    },
    yield: {
      title: "Investments nach Rendite",
      tooltip:
        'Hoch: Der Ertrag von Wertpapieren wird als "hoch" eingestuft, wenn die Rendite pro Jahr über 12 Prozent beträgt.<br/><br/>Moderat: Der Ertrag von Wertpapieren wird als "moderat" eingestuft, wenn die Rendite pro Jahr zwischen 6 und 12 Prozent beträgt.<br/><br/>Gering: Der Ertrag von Wertpapieren wird als "gering" eingestuft, wenn die Rendite pro Jahr unter 6 Prozent beträgt.',
      unclassified: "Nicht klassifiziert",
      numberToWord: {
        "0": "Gering",
        "1": "Moderat",
        "2": "Hoch",
      },
    },
    tag: {
      assignTitle: "Kategorien zuweisen",
      title: "Ihre selbst gewählte Gruppierung",
      unclassified: "Nicht klassifiziert",
    },
    investmentType: {
      title: "Investments nach Typ",
      types: {
        "11_stock": "Aktien",
        "21_fund": "Fonds",
        "31_bond": "Anleihen",
        "41_cash": "Cash",
        "51_certos": "Zertifikate / OS",
        "61_pmetals": "Edelmetalle",
        "71_massets": "Sachwerte",
        "81_fcurr": "Währungen / Krypto",
        "22_etf": "ETF",
        "91_managed": "Robo / Crowd",
      },
    },
    currency: {
      title: "Investments nach Währung",
    },
    region: {
      assignTitle: "Region zuweisen",
      title: "Investments nach Region",
    },
    industry: {
      assignTitle: "Branche zuweisen",
      title: "Investments nach Branche",
    },
  },
  investmentTypeClassification: {
    types: {
      "11_stock": "Aktien",
      "21_fund": "Fonds",
      "31_bond": "Anleihen",
      "41_cash": "Cash",
      "51_certos": "Zertifikate / OS",
      "61_pmetals": "Edelmetalle",
      "71_massets": "Sachwerte",
      "81_fcurr": "Währungen / Krypto",
      "22_etf": "ETF",
      "91_managed": "Robo / Crowd",
    },
  },
  newsPage: {
    title: "News",
    noNews: "Keine News verfügbar",
    loadError: "Nachrichten konnten nicht geladen werden.",
  },
  communityPage: {
    title: "Community",
    noThreads: "Keine Diskussionen verfügbar",
    loadError: "Diskussionen konnten nicht geladen werden.",
    threadMeta: {
      lastPost: "Letzter Beitrag von {{author}}",
      replies_one: "{{count}} Antwort",
      replies_other: "{{count}} Antworten",
    },
  },
  dividendPlannerPage: {
    title: "Dividendenerträge",
    addButton: "Hinzufügen",
    portfolio: "Portfoliowert",
    statistics: {
      portfolioValue: "Portfoliowert",
      received: "Erhaltene Dividenden",
      yield: "Dividenden-Rendite",
      predicted: "Vorhersage",
      predictedYield: "Vorhersage-Rendite",
      cagr: "CAGR",
      currentYear: "Aktuelles Jahr",
      year: "Jahr {{year}}",
      years_one: "{{count}} Jahr",
      years_other: "{{count}} Jahre",
    },
    chart: {
      title: "Dividenden aktuelles Jahr",
      dividendYield: "Dividendenrendite",
      lastYear: "vergangenes Jahr",
      total: "Gesamt",
      tooltipReceived: "erh. Div",
      tooltipPredicted: "mög. Div",
    },
    myDividends: "Meine Dividenden",
    exportPdfBtn: "Export as PDF",
    predictDropdown: {
      predictYears: "Jahre vorhersagen",
      hideForecast: "Vorhersage ausblenden",
      list: {
        nextYear: "Nächstes Jahr simulieren",
        twoYears: "2 Jahre simulieren",
        fiveYears: "5 Jahre simulieren",
        tenYears: "10 Jahre simulieren",
      },
    },
    tabs: {
      overview: "Übersicht",
      calendar: "Dividendenkalender",
    },
    chips: {
      table: "Tabellenansicht",
      calendar: "Kalenderansicht",
    },
    forecast: "Vorhersage",
    showAll: "Alle anzeigen",
    showLess: "Weniger anzeigen",
    showMore: "mehr anzeigen",
    calendar: {
      noData: "Keine Dividenden",
    },
    dividendContains_one: "{{count}} Dividende erhalten",
    dividendContains_other: "{{count}} Dividenden erhalten",
    searchPlaceholder: "Suche",
    quote: "Kurs",
    table: {
      name: "Name",
      dueIn: "Fällig im",
      dividendAmount: "Dividende /\nBetrag",
      yieldPrice: "Pers. Rendite /\nKaufpreis",
      currentYP: "Aktuelle Rendite /\nAktueller Kurs",
      dividend: "Dividende",
      amount: "Betrag",
      personalYield: "Pers. Rendite",
      purchasePrice: "Kaufpreis",
      currentYield: "Aktuelle Rendite",
      currentPrice: "Aktueller Kurs",
      sharesShort: "St.",
      groupByMonth: "Nach Monat gruppieren",
      expected: "Vorraussichtlich",
      notRecorded: "Dividende nicht erfasst",
      noFound: "Nichts gefunden",
      dividendPerShare: "Dividende je Aktie",
      shares: "Anzahl",
      tax: "Steuer & Gebühren",
      paymentDate: "Zahltag",
      banner: {
        title: "Keine Steuerdaten eingetragen",
        text: "Wir können Ihre Nettobeträge berechnen und hier anzeigen, wenn Sie Ihre Steuerdaten angeben",
        supplementBtn: "Steuerdaten ergänzen",
        notNowBtn: "Jetzt nicht",
      },
      expand: {
        dividends: "Dividende",
        amount: "Betrag",
        currentYield: "Aktuelle Rendite",
        personalReturns: "Persönliche Rendite",
        gross: "(Brutto)",
        net: "(Netto)",
        grossTooltip: "Bruttobetrag (vor Steuern)",
        netTooltip: "Nettobetrag (nach Steuern)",
      },
    },
  },
  csvImport: {
    title: "CSV importieren",
    formatSelector: {
      label: "CSV-Format wählen",
    },
    csvUpload: {
      text: "CSV hierhin ziehen oder auswählen",
      error:
        "Fehler beim Upload. Bitte überprüfe, ob die hochgeladene Datei dem Format entspricht, oder versuche es mit einer anderen Datei.",
      genericHint:
        "Bitte die CSV-Datei mit den Transaktionsdaten importieren. Ein generisches CSV-Template kann <linkText>hier heruntergeladen</linkText> werden. Darüber hinaus werden folgende Formate unterstützt:",
      currencyWarning:
        "Wichtig: Der CSV Import unterstützt keine Umrechnung von Fremdwährungen. Bitte sicherstellen, dass alle Buchungen und Transaktionen in Euro angegeben sind.",
      incompatible: {
        "01_depot":
          "Der Import von Cash-Transaktionen in ein Depot ist nicht möglich. Bitte ein Konto auswählen, um die Cash-Transaktionen aus dem CSV-File zu importieren.",
        "02_cash":
          "Der Import von Wertpapier-Buchungen in ein Konto ist nicht möglich. Bitte ein Depot auswählen, um die Wertpapier-Buchungen aus dem CSV-File zu importieren.",
      },
    },
    banksTable: {
      depot: "Depot-Buchungen",
      account: "Konto-Transaktionen",
      emptyText: "Es wurden keine Buchungs- oder Transaktionsbanken gefunden.",
      loading: "Lade Buchungs- oder Transaktionsbanken...",
    },
    edit: "Bearbeiten",
    delete: "Löschen",
    parsingResults: {
      date: "Datum",
      name: "Name",
      number_of_lots: "Anzahl",
      number_of_lots_bond: "Betrag",
      security_price: "Einstandkurs",
      commission: "Gebühren",
      isin: "ISIN",
      tax_amount: "Steuern",
      transaction_type: "Transaktionstyp",
      asset_type: "Investmentart",
      currency: "Währung",
      exchange_rate: "Wechselkurs",
      tax_and_commission_in_eur: "Steuern und Gebühren in EUR",
      error: "Eintrag für {{name}} fehlt",
      saveSuccess: "Transaktionen wurden erfolgreich importiert",
      savePending: "Import wird verarbeitet, bitte warten...",
      saveError: "Beim Speichern von Transaktionen ist ein Fehler aufgetreten",
      correctionHint:
        "Bitte korrigieren Sie erst alle fehlerhaften Transaktionen, bevor Sie sie importieren.",
      allCorrected:
        "Alle fehlerhaften Transaktionen wurden erfolgreich korrigiert.",
    },
    cashParsingResults: {
      bank_booking_date: "Datum",
      counterpart_name: "Name",
      counterpart_iban: "IBAN",
      purpose: "Buchungsinformationen",
      amount: "Betrag",
      error: "Eintrag für {{name}} fehlt",
    },
  },
  transactionUpload: {
    title: "Transaktionen importieren",
    transactionTypes: {
      buy: "Kauf",
      sell: "Verkauf",
      dividend: "Dividende",
      book_in: "Einbuchung",
      book_out: "Ausbuchung",
    },
    dropOrSelectFile: "PDFs hierhin ziehen oder auswählen",
    dropOrSelectFileHint: "Nicht mehr als 10 Dateien mit jeweils bis zu 2 MB",
    newInvestment: "Neu",
    newTransaction: "Neu",
    updateTransaction: "Update",
    tax: "Steuern",
    fee: "Gebühren",
    persistData: "Positionen importieren",
    depot: "Depot",
    ignoreErrors: "Fehler ignorieren",
    success: {
      importSuccess: "Import erfolgreich",
      importDetails: "Importierte Positionen",
      toDepot: "Zurück zum Depot",
      toInvestments: "Zurück zum Investments",
    },
    somethingWrong:
      "Es ist ein Fehler aufgetreten und wir konnten die Datei nicht richtig analysieren. Bitte überprüfen Sie Ihre Dateidaten.",
    placeholder: "Depot wählen",
  },
  authContext: {
    loginTitle: "Login",
    emailConfirmationTitle: "Bitte bestätigen Sie Ihre Email Adresse",
  },
  emailConfirmation: {
    line1:
      "Wir haben Ihnen eine Email zur Bestätigung Ihres Accounts gesendet. Bitte schließen Sie die Registrierung durch klick auf den in der Email enthaltenen Bestätigungslink ab.",
    line2:
      "Sollten Sie keine Email erhalten haben, so überprüfen Sie bitte ggf. auch Ihren Spam-Ordner.",
    success:
      "Wir haben Ihnen eine Email zur Bestätigung Ihres Accounts gesendet.",
    logout: "Anmeldung abbrechen",
    button: "Email erneut senden",
    confirmationExpiredError:
      "Registrierung konnte nicht bestätigt werden. Ggf. ist der verwendete Bestätigungslink bereits ungültig.",
  },
  netfondsConsent: {
    title: "Cashback: One-Click Import",
    heading: "Neu: One-Click Datenimport",
    teaser:
      "Wir freuen uns, nun exklusiv für unsere Cashback-Kunden einen schnellen und reibungslosen Depot-Import bieten zu können.",
    description:
      "Importieren Sie Ihre Cashback-Depots mit nur einem Klick in den {{appName}} Finanzmanager und verbessern Sie Ihre Rendite mit unseren innovativen Finanztools.",
    activateDataImport: "Datenimport aktivieren",
    doNotActivateDataImport: "Datenimport nicht aktivieren",
    deactivated: "One-Click Import ist deaktiviert",
    howToActivate:
      "Sie können den One-Click Import jederzeit in Ihrem <1>Cashback-Dashboard</1> aktivieren.",
    done: "Zurück zum Dashboard",
    changedYourMind: "Import doch aktivieren?",
    selectAccountHolders: "Kontoinhaber wählen",
    selectAccountHoldersDescription:
      "One-Click import wird für die gewählten Kontoinhaber aktiviert.",
    importingData: "Depots werden importiert...",
    importingDataDescription:
      "Wir importieren Ihre Wertpapier und Transaktionsdaten. Sollten Sie über sehr viele (historische) Transaktionen verfügen, so kann der Import mehrere Minuten in Anspruch nehmen.",
    somethingWrong: {
      title: "Import fehlgeschlagen",
      contactSupport:
        "Bitte kontaktieren Sie unseren Support unter {{supportEmail}}, sollte dieses Problem mehrfach auftreten.",
    },
    deleteAccounts: {
      heading: "Bereits importierte Depots löschen?",
      teaser:
        "Es wurden bereits Depots und Konten über die Cashback-Schnittstelle importiert. Möchten Sie diese nun löschen?",
      delete: "Depots löschen",
      keep: "Daten beibehalten",
    },
    breadcrumbs: {
      title: "One-Click Import",
    },
  },
  addDividendWizard: {
    title: "Dividenden",
    breadcrumbs: {
      create: "Dividende hinzufügen",
    },
    addManualDividendStep: {
      title: "Tragen Sie die Angaben zur Dividende ein",
      date: "Datum",
      securityPrice: "Betrag",
      exchangeRate: "Wechselkurs",
      taxAmount: "Steuern",
      commission: "Gebühren",
      taxAndCommissionInEur: "Steuern und Gebühren in EUR?",
      amount: "Summe",
      amountAC: "Summe (EUR)",
      errors: {
        title: "Fehler bei Daten-Validierung",
      },
    },
    confirmManualDividendStep: {
      title: "Zusammenfassung Ihrer Angaben zur Dividende",
      amount: "Betrag:",
      date: "Datum:",
      tax: "Steuern:",
      commission: "Gebühren:",
      exchangeRate: "Wechselkurs:",
      total: "Summe:",
      totalAC: "Summe (€):",
      saveButtonLabel: "Speichern",
    },
  },
  batchDividendsWizard: {
    title: "Dividenden",
    listDividendsStep: {
      title: "Wählen Sie die aussstehenden Dividenden aus",
      subtitle:
        "Die ausgewählten Dividenden werden automatisch in Ihr Depot importiert",
      splitAdjust: "Splitbereinigt",
    },
    dividendsTable: {
      headers: {
        date: "Datum",
        amount: "Betrag",
        lots: "Stück",
      },
    },
    taxRequestStep: {
      taxQuestion: "Möchten Sie einen Steuersatz anwenden?",
      acceptTax: "Ja",
      declineTax: "Nein",
    },
    taxInputStep: {
      title: "Geben Sie Ihren Steuersatz ein",
      customTaxLabel: "Steuersatz",
    },
    summaryStep: {
      title: "Zusammenfassung Ihrer Dividenden- und Steuerdaten",
      saveButtonLabel: "Speichern",
      dividendsTable: {
        headers: {
          date: "Datum",
          amount: "Erhalten",
          tax: "Steuern",
          total: "Summe",
        },
      },
    },
  },
  editDividendWizard: {
    title: "Dividende Bearbeiten",
  },
  transactionWizard: {
    new: {
      title: "Investment hinzufügen",
    },
    manual: {
      title: "Investment von Hand erstellen",
    },
    add: {
      title: "Buchung hinzufügen",
    },
    edit: {
      title: "Buchung bearbeiten",
    },
    searchSymbolsStep: {
      title: "Wertpapiere suchen",
      noQuoteModal: {
        title: "Keine automatische Kursversorgung",
        text: "Für das ausgewählte Wertpapier können wir leider keine automatische Kursaktualisierung zur Verfügung stellen. Bitte erstellen Sie den Eintrag für das Investment manuell und aktualisieren Sie die Kurse bei Bedarf selbst.",
        confirm: "Manuelles Investment erstellen",
      },
    },
    selectCurrencyStep: {
      title: "Investment-Währung wählen",
      currency: "Währung",
      tryPlusMessage: "Fremdwährungen sind ein PLUS Feature.",
    },
    investmentTypeStep: {
      title: "Art des Investments",
    },
    bookingTypeStep: {
      title: "Was möchten Sie erfassen?",
      mostUsed: "Häufig verwendet",
      specials: "Weitere Transaktionsarten",
      buy: "Kauf",
      sell: "Verkauf",
      book_in: "Einbuchung (Book-in)",
      book_out: "Ausbuchung (Book-out)",
      switch: "Tausch / Fusion",
      retained_dividend: "Gratisaktien / Thes. Dividende",
      carve_out: "Carve-out",
      split: "Split",
      disabledInformation:
        "Diese Buchung ist nur für bestehende Investments verfügbar. Bitte verwenden Sie die Investment-Optionen um diese Buchung auszuwählen.",
    },
    priceAndDateStep: {
      title: "Orderdaten",
      date: "Datum",
      numberOfLots: "Stücke",
      numberOfLotsPercent: "Betrag",
      numberOfLotsGram: "Gramm",
      numberOfLotsOunces: "Unzen",
      currency: "Währung",
      securityPrice: "(Historischer) Einstandskurs",
      bookOutPrice: "Ausgebucht für",
      entryQuote: "Kurs",
      exchangeRate: "Wechselkurs",
      commission: "Gebühren",
      taxAmount: "Steuern",
      taxAndCommissionInEur: "Steuern und Gebühren in EUR?",
      totalAmount: "Summe",
      totalAmountAC: "Summe (EUR)",
      depotValuationAfterBooking: "Depotwert nach dieser Buchung",
      gram: "g",
      ounces: "oz",
      lots: "St.",
      comment: "Meine Notizen",
    },
    ratioAndDateStep: {
      title: "Split",
      date: "Datum",
      ratio: "Verhältnis",
      isReverse: "Reverse Split?",
    },
    nameAndDepotStep: {
      title: "Name und Depot wählen",
      name: "Name",
      selectDepot: "Depot wählen",
      newDepot: "Neues Depot",
      comment: "Meine Notizen:",
      investmentExists: "Sie halten bereits {{lots}} Stück in diesem Depot",
    },
    newDepotStep: {
      title: "Neues Depot erstellen",
      name: "Depotname",
    },
    inputFieldWithRevert: {
      revert: "Zurücksetzen",
      revertDescription: "Auf ursprünglichen Wert von {{value}} zurücksetzen",
    },
    summaryStep: {
      title: "Zusammenfassung",
      date: "Datum",
      entryQuote: "Kurs",
      securityPrice: "(Historischer) Einstandskurs",
      exchangeRate: "Wechselkurs",
      expenses: "Nebenkosten",
      totalAmount: "Gesamt",
      totalAmountAC: "Gesamt (€)",
      persist: "Speichern",
      currency: "Währung",
    },
    splitPreviewStep: {
      title: "Split wird angewandt auf:",
      titleReverse: "Reverse-Split wird angewandt auf:",
      persist: "Speichern",
    },
    persistedStep: {
      title: "Daten gespeichert",
      showInvestments: "Weiter zu Investments",
    },
    somethingWrong: {
      title: "Interner Fehler",
      contactSupport:
        "Bitte kontaktieren Sie unseren Support unter {{supportEmail}}, sollte dieses Problem mehrfach auftreten.",
      done: "Zurück zu Investments",
    },
  },
  symbolSearch: {
    loading: "Lade...",
    title: "Wertpapier-Suche",
    searchLabel: "Name, ISIN, WKN",
    searchPlaceholder: "Name, ISIN, WKN",
    noData: "Leider keine Ergebnisse",
    examples: "Beispiele",
    example1: "Daimler oder DE0007100000",
    example2: "Bitcoin oder BTC",
    example3: "Gold oder Silber",
    example4: "Dollar oder USD",
    manualInvestmentLabel: "Wert nicht verfügbar?",
    manualInvestment: "Manuelles Investment erstellen",
  },
  sidebar: {
    header: {
      title: "Finanzmanager ",
      testPremium: "Premium Testen",
    },
    footer: {
      phoneInfo: "Mo. bis Fr. 9-19 Uhr erreichbar",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
      disclaimer: "Haftungsausschluss",
      wealthApi: "wealthAPI GmbH",
    },
  },
  appSidebar: {
    searchField: "Suche: Name, ISIN, WKN",
    menu: {
      accounts: "Konten",
      admin: "Administration",
      capitalMeasure: "Capital Measure",
      cashbackBookings: "Cashback Bookings",
      securitiesAdmin: "Securities Admin.",
      bankAdmin: "Bank Admin. & Reports",
      other: "Other Admin.",
      isinChanges: "ISIN Changes",
      securityType: "Security Type Changes",
      assetReport: "Asset Report",
      apiRefresh: "Historic Quotes Refresh",
      cryptoRefresh: "Crypto Currencies",
      backToLegacy: "Zurück zu v1",
      bankEvents: "Connection Events",
      bankLogs: "Bank Logs",
      bankMessages: "Bank Messages",
      bankHealth: "Bank Health Reports",
      cashback: "Cashback",
      analyse: "Analyse",
      names: "Preferred Names",
      mergers: "Mergers",
      spinOffs: "Spin-Offs",
      purchaseRight: "Purchase Rights",
      cashflowAnalyzer: "Cashflow-Analyzer",
      contractAnalyzer: "Contract-Analyzer",
      contractAnalyzerV2: "Contract-Analyzer V2",
      providerName: "Provider name",
      etfs: "ETF/ETC Classifications",
      logos: "Company Logo",
      classification: "Klassifizierung",
      community: "Community",
      contracts: "Contracts",
      depots: "Depots",
      depotsAndAccounts: "Depots & Konten",
      dividendPlanner: "Erträge",
      dividends: "Dividends",
      home: "Home",
      interfaces: "Interfaces",
      investments: "Investments",
      logout: "Logout",
      newCashback: "Neue Buchung",
      news: "News",
      oneClickImport: "One-Click Import",
      overview: "Übersicht",
      performance: "Depotanalyse",
      portfolio: "Portfolio",
      profile: "Profil",
      risk: "Return and risk",
      settings: "Einstellungen",
      splits: "Splits",
      watchlists: "Watchlists",
      depotCheck: {
        main: "Depotoptimierung",
        questionnaire: "Fragebogen",
      },
    },
  },
  quickBar: {
    home: "Home",
    investments: "Investments",
    analyse: "Analyse",
    depots: "Depots",
  },
  premium: {
    tryPlusMessage:
      "Holen Sie mehr für sich raus und testen Sie {{appName}} <1>PLUS</1> noch heute kostenlos!",
    tryProMessage:
      "Holen Sie mehr für sich raus und testen Sie {{appName}} <1>PRO</1> noch heute kostenlos",
    tryPlus: "Jetzt kostenlos PLUS testen",
    tryPro: "Jetzt kostenlos PRO testen",
    bnBlurOverlay: {
      title: "Alle Premium-Features freischalten",
      subtitle:
        "Verbinde dein Smartbroker+ Depot und nutze Dividenden-Analyse, Portfolio-Auswertung und mehr — dauerhaft kostenlos.",
      connectDepotLabel: "Depot verbinden",
      openDepotLabel: "Jetzt Depot eröffnen",
    },
    smartbrokerPlusExpired: {
      title: "Premiumfunktionen nicht mehr aktiv",
      close: "Hinweis schließen",
      outdated: {
        text: "Nicht mehr für Premium freigeschaltet?\nSmartbroker+ Depot aktualisieren und Premiumfunktionen in PortfolioPlus wieder nutzen.",
        cta: "Depot aktualisieren",
      },
      deleted: {
        text: "Nicht mehr für Premium freigeschaltet?\nSmartbroker+ Depot erneut importieren und Premiumfunktionen in PortfolioPlus wieder nutzen.",
        cta: "Depot importieren",
      },
    },
    featuresModal: {
      brand: "{{appName}} premium",
      title: "Exklusive Inhalte freischalten",
      subtitle: "Ihr kostenloser Zugang zu professionellen Anlegerwerkzeugen",
      features: {
        dividends: "Dividendenkalender",
        returns: "Renditeansicht",
        classifications: "Eigene Klassifizierungen",
      },
      freeBox: {
        title: "Komplett kostenlos. Keine Folgekosten.",
        text: "Der Zugang zu allen Premium-Features ist dauerhaft gratis — verbunden mit einem kostenlosen Smartbroker+-Depot, das Sie jederzeit wieder kündigen können.",
      },
      howToProceed: "Wie möchten Sie fortfahren?",
      connectDepot: {
        title: "Smartbroker+ -Depot verknüpfen",
        subtitle: "Ich habe bereits ein Depot",
      },
      openDepot: {
        title: "Jetzt kostenlos Depot eröffnen",
        subtitle: "Ich habe noch kein Smartbroker+ -Depot",
      },
    },
  },
  onlyForProBlock: {
    title: "Nur für Premium Mitglieder",
    updateToPro: "Jetzt Premium freischalten",
  },
  portfolioLimit: {
    tooltipText:
      "Im kostenfreien Account ist der Import auf maximal 2 Portfolios limitiert. Der Import weiterer Portfolios ist nur für Premium Mitglieder möglich.",
  },
  loggedAs: "Eingeloggt als {{username}}",
  intervalSelector: {
    compact: {
      oneWeek: "1W",
      oneMonth: "1M",
      sixMonths: "6M",
      oneYear: "1J",
      sinceBeginning: "Seit Beginn",
    },
    oneWeek: "1 Woche",
    oneMonth: "1 Monat",
    oneYear: "1 Jahr",
    sinceBeginning: "Seit Beginn",
  },
  dateRangePickerDialog: {
    submitButton: "Übernehmen",
    cancelButton: "Zurücksetzen",
  },
  aggregatedChart: {
    legend: {
      overview: "Gesamtübersicht",
      securities: "Wertpapiere",
      accountsAndCards: "Konten & Karten",
    },
  },
  customTooltip: {
    securitiesLabel: "Wertpapiere",
    cardsAndAccountsLabel: "Konten & Karten",
  },
  userDetails: {
    lastLogin: "Letzter Login:",
    hello: "Hallo",
  },
  sideBarMenu: {
    title: "Whitebox Analyze",
    allAssets: "Gesamtvermögen",
    securities: "Wertpapiere",
    cardsAndAccounts: "Konten & Karten",
    settings: "Einstellungen",
    help: "Hilfe & Support",
    logout: "Abmelden",
    myWhiteboxSecurities: "Meine Whitebox-Anlagen",
    mySecurities: "Meine Depots",
  },
  securitiesChart: {
    legend: {
      overview: "Gesamtübersicht",
      holdings: "Einzeltitel",
      etfs: "ETF",
      funds: "Fonds",
      bonds: "Anleihen",
      derivative: "Derivate",
    },
    typeSwitcher: {
      performance: "Performance",
      valuation: "Wert",
      disabledTooltip:
        "Ein Vergleich der Werte kann nur im Modus ‘Performance’ vorgenommen werden",
    },
  },
  promotionTeaser: {
    title: "Verbessern Sie Ihre Renditechancen!",
    desc: "Dieses Depot könnte sich als Whitebox-Anlage um einiges besser entwickeln und bis zu 5% mehr Rendite/Jahr erwirtschaften.",
    disclaimer:
      "This is a disclaimer and/or risk information, if we need to show one here, when we advertise a higher roi with a Whitebox Investment.",
    buttonMore: "Mehr erfahren",
    buttonNo: "Nein, danke",
    percent: "+5%",
    percentSubtitle: "bis zu 5% mehr im Jahr",
  },
  investmentsPage: {
    overview: "Übersicht",
    isinInvalid: "Die ISIN ist ungültig",
    header: {
      title: "Investments",
      actions: {
        newDepot: "Neues Depot",
        newPortfolio: "Neues Portfolio",
        newTransaction: "Neue Transaktion",
        main: "Neues Investment",
        create: "Manuell",
        uploadPdf: "PDF Importieren",
        uploadCsv: "CSV Importieren",
      },
    },
  },
  portfolioShare: {
    share: "Teilen",
    banner: {
      portfolio: 'Du siehst gerade das Dashboard "{{portfolio}}".',
      createYourOwn: "Erstelle jetzt dein eigenes Dashboard",
      toMyDashboard: "Zu meinem Dashboard",
      register: "Anmelden",
    },
    privatePortfolio: {
      noAccess: "Du hast keinen Zugriff auf dieses Portfolio.",
      close: "Account erstellen",
    },
    modal: {
      title: "Ansicht festlegen",
      secondTitle: "Dashboard teilen",
      table: {
        selectAll: "Alle Auswählen",
        name: "Name",
        bank: "Bank",
      },
      selectButton: "Portfolio zeigen",
      shareButton: "Dashboard teilen",
      acceptButton: "Übernehmen",
      goToPortfolio: "Vorschau ansehen",
      publishButton: "Dashboard veröffentlichen",
      closeButton: "Schließen",
      cashPositionsShared:
        "Die Cash-Position deiner Verrechnungskonten werden ebenfalls geteilt, wenn dein Dashboard öffentlich ist.",
      private: "Privat",
      privateTooltip:
        "Mit dieser Auswahl bleiben deine Portfolios nur für dich einsehbar. Wenn du deine Portfolios bereits öffentlich geteilt hast, kannst du die Sichtbarkeit hier wieder sperren. Die öffentliche Ansicht ist dann wieder deaktiviert.",
      public: "Öffentlich",
      publicTooltip:
        "Mit dieser Auswahl kannst du dein Portfolio mit anderen teilen. Du kannst absolute oder prozentuale Werte anzeigen lassen. Wenn du prozentuale Werte anzeigst, wissen andere nicht, wieviel Kapital du investiert hast.",
      onlyPercentage: "Nur prozentuale Werte anzeigen",
      dashboardName: "Öffentlicher Dashboard Name",
      dashboardName_placeholder: "z.B. 70/30 Portfolio",
      linkWasCopied: "Der Link zu deinem Dashboard wurde kopiert.",
      linkToDashboard: "Link zum Dashboard",
      copyLink: "Link kopieren",
    },
    modale: {
      acceptButton: "",
    },
  },
  investmentEditPage: {
    header: "Bearbeiten",
    breadcrumbs: {
      edit: "Bearbeiten",
    },
    noInvestment: "Investment nicht gefunden",
    tabs: {
      basic: "Stammdaten",
      quoteData: "Kurse",
      advanced: "Erweitert",
    },
    basicTab: {
      name: "Name",
      depot: "Depot",
      industry: "Branche",
      region: "Region",
      customGroup: "Eigene Gruppe",
      saveButton: "Speichern",
      saved: "Daten gespeichert",
    },
    quoteDataTab: {
      selectedText: "Gewählt:",
      nothingSelectedText: "Bitte Wert auswählen",
      saveButton: "Speichern",
    },
    advancedTab: {
      investmentType: "Typ",
      investmentCurrency: "Währung",
      isin: "ISIN",
      wkn: "WKN",
      comment: "Meine Notizen",
      commentSaveError: "Notizen konnten nicht gespeichert werden",
      saveButton: "Speichern",
    },
  },
  itCardsMiniCard: {
    lastTransaction: "Letzte Buchung",
    noTransactions: "Keine Buchungen",
  },
  dashboardPage: {
    allYourAssets: "Vermögensaufstellung ",
    portfolio: "Portfolio",
    investmentsLink: "Gehe zu Investitionen",
    modeBanner: {
      text: "Neu: Ab sofort ist der Rentablo Finanzmanager auch im Dark Mode verfügbar. <linkText>Jetzt Dark Mode ausprobieren</linkText>",
    },
    depot: {
      title_one: "{{count}} Depot",
      title_other: "{{count}} Depots",
      noAccountsTitle: "Keine Depots",
      noAccountsSubtitle:
        "Sie haben bisher noch keine Depots hinzugefügt, möchten Sie das jetzt tun?",
      noAccountsButtonText: "Depots hinzufügen",
    },
    currentAssetsBlock: {
      chart: "Chart",
      gainersLosers: "Gewinner & Verlierer",
      gainersLosersShort: "G&V",
      statistic: {
        returnOnInvestment: "Kursgewinn",
        cash: "Cash",
        dividends: "Dividenden",
        realizedGain: "Realisierte Gewinne",
      },
    },
    investments: {
      title_one: "{{count}} Investment",
      title_other: "{{count}} Investments",
      noAccountsTitle: "Keine Investments",
      noAccountsSubtitle:
        "Sie haben bisher noch keine Investments hinzugefügt, möchten Sie das jetzt tun?",
      noAccountsButtonText: "Investments hinzufügen",
    },
    account: {
      title_one: "{{count}} Konten",
      title_other: "{{count}} Konten",
      noAccountsTitle: "Keine Konten",
      noAccountsSubtitle:
        "Sie haben bisher noch keine Konten hinzugefügt, möchten Sie das jetzt tun?",
      noAccountsButtonText: "Konten hinzufügen",
    },
    whitebox: {
      title_one: "{{count}} Whitebox-Anlage",
      title_other: "{{count}} Whitebox-Anlagen",
      noAccountsTitle: "Keine Whitebox-Anlagen",
      noAccountsSubtitle:
        "Sie haben bisher noch keine Whitebox-Anlagen hinzugefügt, möchten Sie das jetzt tun?",
      noAccountsButtonText: "Whitebox-Anlagen hinzufügen",
    },
    cashbackCard: {
      withSubscriptions: {
        title: "Cashback Buchung",
        text: "Für Ihre Buchung benötigen wir noch folgende Dinge:",
        text_processed: "Ihre Buchung ist in Bearbeitung:",
        text_active: "Sie können Ihre Cashback-Depots jetzt importieren",
      },
      noSubscriptions: {
        title: "Bonus erhalten",
        subtitle: "Werbe einen Freund",
        text: "Bringe einen Freund zu {{appName}} und erhalte 15€ als Belohnung.",
      },
      statusMessage: {
        processed: "Aktiv",
        incomplete: "Entwurf; bitte vervollständigen",
        in_progress: "Bitte Unterlagen Einreichen",
        internal_processing: "Unterlagen erhalten - In Bearbeitung",
        processing_at_bank: "An Bank weitergeleitet",
        processing_at_bank_reduced: "Eröffnungsprozess an Bank weitergeleitet",
        contract_terminated: "Gekündigt",
      },
    },
    netfondsImportCard: {
      consentRequired: {
        title: "Ihre Einwilligung wird benötigt",
        body: "Für den Import ihrer Cashback-Depots benötigen wir ihre Einwilligung",
      },
      importAvailable: {
        title: "One-Click Import verfügbar",
        body: "Importieren Sie Ihre Cashback-Depots mit nur einem Klick",
      },
      detailsButton: "Details",
    },
    header: {
      title: "Dashboard",
      welcomePhrases: {
        morning: "Guten Morgen",
        afternoon: "Guten Tag",
        evening: "Guten Abend",
      },
    },
    dashboard: {
      addPortfolio: "Portfolio hinzufügen",
      header: {
        subheader: "Aktuelles Vermögen",
        add: "Portfolio hinzufügen",
      },
      noDataFirstLine: "Aktuell liegen noch keine Daten vor.",
      noDataSecondLine:
        "<linkText>Bitte importiere</linkText> deine Portfolios und Konten.",
      mainDataSection: {
        cash: "Cash",
        holdings: "Holdings",
        assets: "Vermögen",
        returnOnInvestment: "Kursgewinn",
        rateOfReturn: "Interner Zinsfuß",
        dividends: "Dividenden",
        realizedGain: "Realisierte Gewinne",
      },
      includeDividends: "Inklusive Dividenden",
      cashTable: {
        header: "Cash",
      },
      investmentsTable: {
        header: "Holdings",
        columns: {
          name: "Name",
          totalValue: "Gesamtwert",
          change: "Änderung",
          allocation: "Allokation",
        },
        types: {
          "11_stock_one": "Aktie",
          "11_stock_other": "Aktien",
          "21_fund": "Fonds",
          "31_bond_one": "Anleihe",
          "31_bond_other": "Anleihen",
          "41_cash": "Cash",
          "51_certos_one": "Zertifikat / OS",
          "51_certos_other": "Zertifikaten / OS",
          "61_pmetals_one": "Edelmetall",
          "61_pmetals_other": "Edelmetalle",
          "71_massets_one": "Sachwert",
          "71_massets_other": "Sachwerte",
          "81_fcurr_one": "Fremdwährung",
          "81_fcurr_other": "Fremdwährungen",
          "22_etf": "ETF",
          "91_managed": "Robo / Crowd",
        },
      },
      performance: {
        tabs: {
          value: {
            title: "Wert",
            portfolio: "Portfolio",
            investedCapitol: "Investiertes Kapital",
          },
          performance: {
            title: "Performance",
            portfolio: "Portfolio",
            dividends: "Portfolio inkl. Dividenden",
          },
          dividend: {
            title: "Dividende",
            total: "Gesamt",
            predicted: "Erwartet",
            investedCapitol: "Investiertes Kapital",
          },
        },
        rangeName: {
          today: "Heute",
          YTD: "YTD",
          oneYear: "1 Jahr",
        },
        viewInvestedCapital: "Investiertes Kapital anzeigen",
        compare: "Vergleich",
        compareWith: "Vergleichen mit",
        compareTooltip:
          "Vergleichen Sie die Leistung mit einem Wertpapier oder Index.",
        includeDividends: "Inklusive Dividenden",
        selectCompare: {
          placeholder: "Name, ISIN oder WKN eingeben",
        },
      },
      gainersAndLosers: {
        gainers: "Gewinner",
        losers: "Verlierer",
        more: "Mehr erfahren",
        period: "1 Tag",
        noData:
          "Keine Gewinner & Verlierer verfügbar. Bitte die Portfolio-Auswahl ändern oder weitere Investments ergänzen.",
      },
      communityPosts: {
        title: "Meistdiskutiert",
        allDiscussions: "Alle Diskussionen",
        noPosts: "Keine Diskussionen verfügbar",
      },
      arivaTimeline: {
        title: "Aktuelles zu deinen Investments",
        empty: "Keine Timeline-Einträge verfügbar",
        today: "Heute",
        future: "Bevorstehend",
        past: "Gestern",
      },
      newsBlock: {
        title: "Neuigkeiten & Wissen",
        allArticles: "Alle Artikel ansehen",
        item: {
          type: "Finanzblog",
        },
      },
    },
    cashbackSuggestionCard: {
      subtitle: "Noch mehr profitieren!",
      title: "{{amount}} Fonds-Provision p.a.",
      discount: "Inklusive 100% Agio Rabatt",
      button: "Jetzt Geld zurückholen",
    },
  },
  watchlistsPage: {
    header: {
      title: "Watchlists",
    },
    watchlists: {
      title: "Watchlist",
      create: "Neue Watchlist erstellen",
      newWatchlist: "Watchlist hinzufügen",
    },
    createAndEditForm: {
      label: "Name der Watchlist",
      placeholder: "Name der Watchlist",
    },
  },
  watchlistsCreatePage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
      create: "Wertpapier hinzufügen",
    },
    header: {
      title: "Watchlist erstellen",
    },
  },
  watchlistsEditPage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
      edit: "Bearbeiten",
    },
    header: {
      title: "Bearbeiten",
    },
  },
  watchlistSinglePage: {
    header: {
      totalItems_one: "{{count}} Wertpapier",
      totalItems_other: "{{count}} Wertpapiere",
      actions: {
        editWatchlist: "Watchlist bearbeiten",
        deleteWatchlist: "Watchlist löschen",
        addNewItem: "Wertpapier hinzufügen",
      },
      deleteDialog: {
        title: "Watchlist löschen",
      },
    },
    table: {
      noItems: "Keine Wertpapiere vorhanden",
      headers: {
        name: "Name",
        watchPrice: "Beobachtungskurs",
        currentPrice: "Aktueller Kurs",
        changeToday: "Veränd.",
        oneYear: "1 Jahr %",
        threeYear: "3 Jahr %",
        fiveYear: "5 Jahr %",
      },
    },
  },
  singleSecurityPage: {
    breadcrumbs: {
      quotes: "Wertpapier",
    },
    actions: {
      addToDepot: "Zum Depot hinzufügen",
    },
  },
  depots: {
    title: "Portfolios & Konten",
    depotsTitle_one: "{{count}} Depot",
    depotsTitle_other: "{{count}} Depots",
    noAccountsTitle: "Keine Konten",
    noAccountsSubtitle:
      "Sie haben bisher noch keine Konten hinzugefügt, möchten Sie das jetzt tun?",
    noAccountsButtonText: "Konten hinzufügen",
    addManuallyButton: "Investment hinzufügen",
    deleteModal: {
      question: "Dieses Depot löschen?",
    },
  },
  depotPage: {
    breadcrumbs: {
      home: "Home",
      depots: "Depots",
    },
    header: {
      title: {
        mobile: "Depot",
      },
    },
    headerMenu: {
      upload: "PDF Hochladen",
      uploadCsv: "CSV Hochladen",
      update: "Aktualisieren",
      addButton: "Investment hinzufügen",
      edit: "Bearbeiten",
      showUpdateHistory: "Update-Verlauf anzeigen",
      manageBankConnection: "Bankverbindung verwalten",
      transfer: "Depotübertrag",
      changeAccount: "Referenzkonto ändern",
      hide: "Ausblenden",
      show: "Anzeigen",
      delete: "Depot löschen",
      reconnect: "Neu verbinden",
    },
    deleteModal: {
      question: "Dieses Depot löschen?",
      deleteContraAccount: "Verrechnungskonto löschen",
    },
    chart: {
      performanceYTD: "{{changeYTD}} Wertentwicklung",
      performanceToday: "Heute: {{changeToday}}",
      noData: "Aktuell liegen noch keine Daten vor",
    },
    tabs: {
      transactions: "Protokoll",
      investments: "Investments",
    },
    showHistoricSwitch: "Historische anzeigen",
    since: "Seit",
    subcategories: {
      depots: "Depots & Verrechnungskonten",
      cash: "Konten",
      assets: "Edelmetalle & Sachwerte",
      insurance: "Versicherungen",
      crypto: "Krypto",
    },
    addOptions: {
      depots: "Depot",
      cash: "Konten",
      assets: "Edelmetalle & Sachwerte",
      insurance: "Versicherungen",
    },
  },
  depotsSelect: {
    title: "Ansicht festlegen",
    saveButton: "Auswahl bestätigen",
    table: {
      headers: {
        name: "Name",
        bank: "Bank",
      },
    },
  },
  loginPage: {
    header: {
      title: "Bei {{appName}} einloggen",
      subtitle: "Geben Sie Ihre Zugangsdaten ein.",
    },
    form: {
      emailField: "Ihre Email Adresse",
      emailFieldPlaceholder: "name@email.de",
      passwordField: "Passwort",
      passwordFieldPlaceholder: "Passwort eingeben",
      submitButton: "Jetzt Einloggen",
      twoFACodeLabel: "2FA Code eingeben",
      twoFASubmitButton: "2FA bestätigen und einloggen",
      rememberMe: "Angemeldet bleiben",
      requestErrors: {
        loginFailed:
          "Login fehlgeschlagen. <passwordRestoreLink>Haben Sie Ihr Passwort vergessen?</passwordRestoreLink>",
        somethingWrongWithoutStatus:
          "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmals. Kontaktieren Sie unseren Support unter <supportEmailLink>{{email}}</supportEmailLink>, sollte dieses Problem mehrfach auftreten.",
      },
    },
    signupMessage: {
      link: "Registrieren",
      question: "Noch keinen Account?",
    },
    resetPassword: {
      question: "Passwort vergessen?",
      link: "Hier klicken",
    },
    twoFACodeError:
      "Ungültiger oder abgelaufener 2FA Code. Bitte versuchen Sie es erneut und <linkText>loggen Sie sich neu ein</linkText>.",
  },
  signupPage: {
    header: {
      title: "Voller Überblick über Ihre Finanzen",
      subtitle: "{{appName}} ist kostenlos und unverbindlich",
    },
    form: {
      firstName: "Vorname",
      lastName: "Nachname",
      email: "Ihre Email Adresse",
      password: "Passwort",
      acceptedAgb:
        "Ich stimme den {{appName}} <agb>AGBs</agb> und <privacy>Datenschutzbestimmungen</privacy> zu",
      news: "Ich möchte über Produktupdates und Sparangebote informiert werden",
      submitButton: "Bei {{appName}} registrieren",
      rememberMe: "Angemeldet bleiben",
      gender: {
        title: "Anrede",
        male: "Herr",
        female: "Frau",
      },
      errors: {
        agb: "AGB & Datenschutz: Muss angegeben werden",
      },
      requestErrors: {
        somethingWrongWithoutStatus:
          "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmals. Kontaktieren Sie unseren Support unter <supportEmailLink>{{email}}</supportEmailLink>, sollte dieses Problem mehrfach auftreten.",
      },
    },
    loginMessage: {
      linkText: "Jetzt Einloggen",
      question: "Bereits registriert?",
    },
  },
  resetPasswordPage: {
    header: {
      title: "Passwort vergessen",
      subtitle:
        "Bitte geben Sie Ihre Email-Adresse ein; nachfolgend erhalten Sie einen Link zum Zurücksetzen des Passworts per Email.",
    },
    form: {
      email: "Email:",
      submitButton: "Email senden",
      successfulMessage:
        "Wir haben Ihnen eine Email zum Zurücksetzen Ihres Passworts gesendet ({{email}}).",
    },
  },
  assignPasswordPage: {
    header: {
      title: "Neues Passwort vergeben",
    },
    form: {
      password: "Passwort",
      submit: "Passwort ändern",
    },

    success: "Dein Passwort wurde erfolgreich geändert",
    error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
  },
  depotsAccountsPage: {
    noResults: "Keine passenden Ergebnisse gefunden",
    showHiddenItems: "Versteckte Elemente anzeigen",
    chips: {
      all: "Alle",
      "01_depot": "Depots & Verrechnungskonten",
      "02_cash": "Konten",
      "04_insurance": "Versicherungen",
      "05_material_assets": "Edelmetalle & Sachwerte",
    },
    accountChips: {
      manual: "Nutzergeneriert",
      manualTooltip:
        "Bitte Änderungen/Details anhand des Depotauszugs selbst prüfen und ggf. aktualisieren.",
      manualUpdateRequired: "Manuell",
      manualUpdateRequiredTooltip: "Manuelle Aktualisierung erforderlich",
      automatic: "Automatisch",
      automaticTooltip: "Automatische Aktualisierung",
      updated: "Aktualisierung Bank {{date}}",
      edited: "Änderung {{date}}",
    },
  },
  accounts: {
    title: "Konten",
    breadcrumbs: {
      home: "Home",
      add: "Hinzufügen",
    },
    addMobileTitle: "Konten hinzufügen",
    addButton: "Hinzufügen",
    addManuallyButton: "Manuell verwaltet",
    noAccountsTitle: "Keine Konten",
    noAccountsSubtitle: "Keine Konten. Möchten Sie nun Konten hinzufügen?",
    noAccountsButtonText: "Jetzt hinzufügen",
    fillForm: "Manuell gepflegtes Konto erstellen",
    chooseType: "Typ",
    fillFormDepots: "Manuell gepflegtes Portfolio erstellen",
    add: {
      title: "Importieren oder manuell einpflegen?",
      subtitle:
        "Du hast verschiedene Möglichkeiten, deine Daten zu importieren",
      titleBank: "Depots/Konten importieren",
      subtitleBank: "Bitte wähle deine Bank aus",
      titleManual: "Manuell gepflegtes Portfolio erstellen",
      importBank: "Automatisierter Import",
      importManual: "Manueller Import",
      iWantTo: "So möchte ich importieren:",
      bank: "Bankimport",
      importManualDepot: "Manuelles Portfolio erstellen",
    },
    addManually: {
      chooseType: "Kontentyp",
      type: "Typ",
      name: "Name",
      namePlaceholder: "E.g. Mein Depot",
      bank: "Bank",
      bankPlaceholder: "Bank Name, BIC oder IBAN",
      create: "Erstellen",
      back: "Zurück",
    },
    sort: {
      name: "Name",
      bankName: "Bank Name",
      performance: "Kurs/Änderung",
      totalValue: "Gesamtwert",
    },
    showHiddenItems: "Versteckte Elemente anzeigen",
  },
  transactionDetails: {
    productName: "Produktbezeichnung",
    numberOfLots: "Anteile",
    entryQuote: "Kurs",
    assetType: "Asset-Klasse",
    isin: "ISIN",
  },
  transactionsTable: {
    depotValue: "Depotbestand",
    period: "Zeitraum",
    valueDate: "Valuta",
    bookingDate: "Buchtag",
    bookingInformation: "Buchungsinformation",
    value: "Wert",
    noPurpose: "Nicht verfügbar",
    noTransactions: "Keine Transaktionen für den Zeitraum",
    status: {
      edit: {
        title: "Manuelle Daten",
        text: "Kein Handlungsbedarf. Die Daten wurden vom Nutzer manuell eingegeben.",
      },
      link: {
        title: "Bankimport-Daten",
        text: "Kein Handlungsbedarf. Die Bank oder der Broker hat den genauen Betrag und die genaue Stückzahl zu dieser Transaktion übermittelt. Das ist der beste Fall und liefert präzise Daten.",
      },
      returned: {
        title: "Geschätzte Daten",
        text: "Bitte Daten überprüfen. Die Bank oder der Broker hat den genauen Betrag angegeben, aber NICHT die Stückzahl. Die Stückzahl wurde daher auf der Grundlage historischer Kursdaten geschätzt. Dies funktioniert im Allgemeinen gut, wenn es nicht zu viele Transaktionen gibt.",
      },
      warning: {
        title: "Virtuelle Ausgleich-Buchung (Stückzahl unter Null)",
        text: "Handlungsbedarf: Bitte Daten korrigieren. Es musste eine virtuelle Buchung  erstellt werden, um zu verhindern, dass die Stückanzahl zu irgendeinem Zeitpunkt unter Null fällt. Ein solcher Fall kann eintreten, wenn Daten fehlen oder eine Schätzung falsch ist.",
      },
      warningDelta: {
        title: "Virtuelle Buchung (Abweichung bei Stückzahl)",
        text: "Handlungsbedarf: Bitte Daten korrigieren. Es gab eine Abweichung (auch Tracking-Error genannt) zwischen der aus der Auftragshistorie berechneten Stückzahl und der von der Bank gemeldeten Stückzahl. Solche Tracking-Error können aufgrund von Dateninkonsistenzen oder aufgrund von Kapitalmaßnahmen wie Carve-Outs, Depotübertragungen oder Splits auftreten.",
      },
      csv: {
        title: "CSV Import Daten",
        text: "Kein Handlungsbedarf. Der genaue Betrag und die genaue Stückzahl zu dieser Transaktion wurden per CSV Import übermittelt. Das ist der beste Fall und liefert präzise Daten.",
      },
    },
  },
  investmentsTable: {
    noAccountNumber: "Nicht verfügbar",
    noLastSyncDate: "Nicht verfügbar",
    summary: {
      today: "Heute",
      priceGains: "Kursgewinne",
      purchaseValue: "Kaufwert",
      marketValue: "Marktwert",
    },
  },
  bookingsTable: {
    overallValue: "Depotwert",
    period: "Zeitraum",
    valueDate: "Zeitraum",
    investment: "Investition",
    price: "Preis",
    value: "Wert",
    noBookings: "Keine Buchungen für den Zeitraum",
    exchangeRate: "Tauschrate: ",
  },
  assetClassName: {
    "11_stock": "Aktie",
    "71_massets": "Sachwert",
    "91_managed": "Robo / Crowdfunding",
    "21_fund": "Fonds",
    "22_etf": "ETF",
    "51_certos": "Zertifikate/OS",
  },
  accountView: {
    noBank: "Keine Bank",
  },
  accountBox: {
    noBank: "Keine Bank",
  },
  mainChartLayout: {
    timeBrushClose: "Schließen",
    timeBrushOpen: "Verlauf",
  },
  viewLayout: {
    close: "Schließen",
  },
  performanceOverview: {
    gainAndLoss: "GUV (ENTW. + Realisiert)",
    realizedGains: "Realisiert",
    returnOnInvestment: "Kursgewinne",
    performance: "Performance",
  },
  dividendsChart: {
    title: "Dividenden-Entwicklung",
    subtitle: "Die Dividenden-Auszahlungshistorie",
    tooltip:
      "Die Dividenden Auszahlungs-Historie. Erfolgen mehrere Zahlungen pro Jahr, so werden die Werte auf volle Jahre aufsummiert.",
  },
  historicalQuotesChart: {
    year_one: "{{count}} Jahr",
    year_other: "{{count}} Jahre",
    title: "Kursentwicklung",
    subtitle: "Entwicklung der letzten N Jahre bis heute",
    tooltip: "Dies zeigt die Kursentwicklung von N Jahren bis heute.",
  },
  investmentChartTooltip: {
    buy: "Kauf",
    sell: "Verkauf",
    dividend: "Dividende",
    book_in: "Einbuchung",
    book_out: "Ausbuchung",
    retained_dividend: "Thesaur. Dividende",
    purchase_right: "Verkauf Bezugsrechte",
    carve_out: "Carve out",
    split: "Split",
    expected_dividend: "Erwartete Dividende",
  },
  assetTypeBreakdown: {
    allHoldings: {
      title: "Einzeltitel",
      noData: "Keine Einzeltitel",
    },
    funds: {
      title: "Fonds",
      noData: "Keine Fonds",
    },
    etfs: {
      title: "ETF",
      noData: "Keine ETF",
    },
    derivative: {
      title: "Derivate",
      noData: "Keine Derivate",
    },
    bonds: {
      title: "Anleihen",
      noData: "Keine Anleihen",
    },
  },
  breadcrumbs: {
    home: "Home",
    investments: "Investments",
    cashback: "Cashback",
    depotsAccounts: "Portfolios & Konten",
    accounts: "Konten",
    addDividends: "Add dividends",
    recommend: "Empfehlung",
    cashflow: "Cashflow Analyzer",
    contract: "Contract Analyzer",
  },
  tradeRepublic: {
    connectFrom: {
      phone: {
        label: "Telefon",
        helperText: "Internationales Format, ex.: +4915753345623",
      },
      pin: {
        label: "PIN",
        helperText: "vier Stellen, z. B.: 1234",
      },
      submit: "Schicken",
    },
    codeFrom: {
      code: {
        label: "Code aus der App",
        helperText: "vier Stellen, z. B.: 1234",
      },
      submit: "Daten abrufen",
    },
    error: {
      title: "Error",
      message: "Bitte wenden Sie sich an den {{appName}}-Support.",
    },
    success: {
      title: "Success",
      message: "Daten werden im Hintergrund abgerufen. Danke für die Hilfe.",
    },
  },
  accountChart: {
    subtitle: "Aktueller Kontostand",
  },
  admin: {
    logos: {
      title: "Company or emitter logo",
      breadrcumb: "Company logo",
      add: "Add logo",
      searchButton: "Logo",
      isin: "ISIN",
      name: "Name",
      logo: "Logo",
      date: "Date",
      addTitle: "Add logo",
      logoUpload: "Logo hierhin ziehen oder auswählen",
      bannerTitle: "Änderung des aktuellen Logos",
      bannerDescription:
        "Das aktuelle Logo wird durch das neue Logo ersetzt, sobald Sie das neue Logo hochladen und speichern",
      bannerButton: "Okay",
      noLogos: "No logos found",
      deleteThisLogo: "Delete this logo?",
      succesUpload: "Das Logo wurde erfolgreich hochgeladen",
    },
    etfs: {
      title: "ETF/ETC Classification",
      add: "Add classification",
      deleteThisClassification: "Delete this classification?",
      isin: "ISIN",
      name: "Name",
      type: "Classification",
      date: "Date",
      apply: "Search",
      noEtfs: "No ETFs/ETCs found",
    },
    names: {
      title: "Preferred names",
      add: "Add preferred name",
      edit: "Edit preferred name",
      deleteThisName: "Delete this name?",
      isin: "ISIN",
      standardName: "Standard name",
      preferredName: "Preferred name",
      date: "Date",
      search: "Search",
      apply: "Save",
      noNames: "Nothing found",
    },
    assetReport: {
      title: "Asset Report",
      emitters: {
        label: "Fonds- / ETF- Emittent",
        all: "Alle",
        funds: "Fonds-Emittent",
        etfs: "ETF-Emittent",
      },
      emitter: {
        label: "Emittenten auswählen",
        placeholder: "Name eingeben",
      },
      isins: {
        label:
          "ISINs einfügen (Bitte geben Sie die einzelnen ISINs komma-separiert ohne Leerzeichen ein)",
        placeholder: "ISINs einfügen",
      },
      startDate: {
        label: "Datum von (Optional)",
      },
      endDate: {
        label: "Datum bis (Optional)",
      },
      button: "Report generieren",
      table: {
        tabTitle: "Tabelle",
        emitters: "Emittenten",
        isins: "ISINs",
        from: "Datum von",
        startVolume: "Startvolumen",
        to: "Datum bis",
        endVolume: "Endvolumen",
        delta: "Delta",
        total: "Gesamt Betrag:",
      },
    },
    splits: {
      mainPage: {
        breadcrumbs: {
          splits: "Splits verwalten",
        },
        title: "Splits verwalten",
        addButton: "Split",
        noSplits: "Keine Splits gefunden",
        apply: "Anwenden",
        deleteThisSplit: "Diesen Split löschen?",
      },
      editPage: {
        submit: "Speichern",
        breadcrumbs: {
          edit: "Split bearbeiten",
          add: "Split hinzufügen",
        },
      },
    },
    dividends: {
      save: "Speichern",
      close: "Abbrechen",
      clone: "Dividenden kopieren",
      mainPage: {
        title: "Dividenden verwalten",
        breadcrumbs: {
          dividends: "Dividenden verwalten",
        },
        noDividends: "Keine Dividenden gefunden",
        apply: "Anwenden",
        deleteThisDividend: "Diesen Dividend löschen?",
        noIsin: "Keine ISIN angegeben. Bitte geben Sie eine ISIN an",
      },
      cloneModal: {
        title: "Dividenden kopieren",
        success: "Dividenden erfolgreich kopiert",
      },
      addPage: {
        title: "Dividende hinzufügen",
      },
      editPage: {
        title: "Dividende bearbeiten",
        fields: {
          isin: "ISIN",
          amount: "Amount",
          currency: "Currency",
          exDate: "Execution Date",
          paymentDate: "Payment date",
          splitAdjustedAmount: "Split adjusted amount",
          amountInCurrency: "Amount in currency",
          splitAdjustedAmountInCurrency: "Split adjusted amount in currency",
          markedAsDeleted: "Marked as deleted",
          wasCurated: "Was curated",
          isSpecial: "Special",
        },
      },
    },
    interfaces: {
      mainPage: {
        title: "Interfaces verwalten",
        breadcrumbs: {
          interfaces: "Interfaces verwalten",
        },
      },
      editPage: {
        submit: "Speichern",
        breadcrumbs: {
          edit: "Interface bearbeiten",
          add: "Interface hinzufügen",
        },
      },
    },
    bankMessages: {
      title: "Übersicht über Banknachrichten",
      createNew: "Nachricht erstellen",
      breadcrumbs: {
        bankMessages: "Nachrichtenübersicht",
      },
      filterBy: "Filtern nach",
      createSuccess: "Nachricht erfolgreich erstellt",
      createError: "Nachricht konnte nicht erstellt werden",
      deleteSuccess: "Nachricht erfolgreich gelöscht",
      deleteError: "Nachricht konnte nicht gelöscht werden",
      updateSuccess: "Nachricht erfolgreich aktualisiert",
      updateError: "Nachricht konnte nicht aktualisiert werden",
      copySuccess: "Nachricht erfolgreich kopiert",
      copyError: "Nachricht konnte nicht kopiert werden",
      table: {
        severity: "Nachrichtentyp",
        bic: "BIC",
        message_text: "Nachrichtentext",
        valid_until: "Fälligkeit",
        unlimited: "Unbefristet",
        expired: "Abgelaufen",
        expiresToday: "Läuft heute ab",
        expiresIn_one: "Fällig in {{amount}} Tag",
        expiresIn_other: "Fällig in {{amount}} Tagen",
        expiresInHours_one: "Fällig in {{amount}} Stunde",
        expiresInHours_other: "Fällig in {{amount}} Stunden",
        INFO: "Info",
        WARNING: "Warning",
        ERROR: "Error",
        edit: "Bearbeiten",
        copy: "Kopieren",
        delete: "Löschen",
        noData: "Keine Daten",
      },
      form: {
        limited: "Begrenzte Nachricht",
        message_text: "Nachrichtentext",
        message_text_placeholder: "Text eingeben",
        severity: "Schweregrad",
        bic: "BIC",
        start_date: "Date von",
        start_date_tooltip:
          'Bitte wähle das Startdatum für die Anzeige der Nachricht aus. Bei Auswahl des heutigen Tages als Startdatum wird die Nachricht sofort nach Klick auf den Button "Nachricht aktualisieren" angezeigt. Bei Auswahl eines zukünftigen Datums wird die Nachricht am ausgewählten Tag ab 0 Uhr angezeigt.',
        end_date: "Date bis",
        end_date_tooltip:
          "Bitte wähle das Enddatum für die Anzeige der Nachricht aus. Die Nachricht wird am ausgewählten Tag bis 0 Uhr angezeigt.",
      },
      newModal: {
        title: "Nachricht erstellen",
        submit: "Nachricht erstellen",
      },
      editModal: {
        title: "Nachricht noch mal verwenden",
        submit: "Nachricht aktualisiren",
      },
    },
    bankEvents: {
      title: "Bank Connection Events",
      userId: "User ID",
      userId_placeholder: "User ID eingeben",
      table: {
        date: "Datum",
        bankName: "Bank Name",
        faq: "FAQ",
        copyCode: "Code kopieren",
        warning: "Warning",
        error: "Error",
        info: "Info",
        faqTooltip:
          'Der Link führt Dich zu unserem wealthAPI Help Center. Du musst mit Deinen Anmeldedaten bei Zendesk eingeloggt sein, damit Du Zugriff auf unsere FAQ hast. Am besten merkst Du Dir die "message" aus dem Code. Gib die entsprechenden Stichworte in die FAQ-Suche ein, damit Du den passenden Eintrag angezeigt bekommst.',
        noData: "Keine Daten",
      },
    },
    cashbackBookings: {
      title: "Cashback Bookings",
      mandatorLabel: "Filter by mandator (default: all mandators)",
      absByMonth: "Cashback subscriptions absolute by month",
      mailReturnByMonth: "Subscription mail return rate in percent by month",
      averageMailReturn: "Average mail return rate is {{value}}",
      churnByMonth: "Subscription churn rate in percent by month",
      avgChurnRate: "Average churn rate is {{value}}",
      currentAssetsByBank: "Current assets by bank",
      totalManagedByMonth: "Total managed assets by month",
    },
    apiRefresh: {
      title: "Historic Quotes Refresh",
      hqIsin: {
        isinLabel: "ISIN",
      },
      hqTicker: {
        tickerLabel: "Ticker symbol",
        quoteLabel: "Quote provider",
      },
      button: "Refresh",
      successMessage: "Refreshed succesfully",
      errorMessage: "Refresh failed",
    },
    bankLogs: {
      title: "Bank Sync Logs",
      subtitle:
        "Anhand einer User ID kannst Du Dir für einen bestimmten Zeitraum die Importdaten zu einer ausgewählten Bank anzeigen lassen. Die Log Files werden Dir als Code zur Verfügung gestellt, wenn Du auf einen Eintrag in der Tabelle klickst.",
      form: {
        start_date: "Datum von",
        start_date_tooltip:
          "Bitte wähle das Startdatum für den gewünschten Zeitraum aus",
        end_date: "Datum bis",
        end_date_tooltip:
          "Bitte wähle das Enddatum für den gewünschten Zeitraum aus",
        userId: "User ID",
        bank: "Bank",
      },
      table: {
        date: "Zeit",
        logId: "Log ID",
        userId: "User ID",
        noData: "Keine Daten",
      },
    },
    bankHealth: {
      title: "Bank Health Reports",
      tabs: {
        table: "Tabelle",
        chart: "Chartansicht",
        errors: "Tracking error",
      },
      form: {
        start_date: "Datum von",
        start_date_tooltip:
          "Bitte wähle das Startdatum für den gewünschten Zeitraum aus",
        end_date: "Datum bis",
        end_date_tooltip:
          "Bitte wähle das Enddatum für den gewünschten Zeitraum aus",
        bank: "Bank",
        interval: "Intervall",
        interval_tooltip:
          "Bitte wähle das gewünschte Zeit-Intervall für die Analyse aus. Du kannst zwischen 15 Minuten-, 1 Stunden-, Tages- und Wochen-Intervall wählen. Bitte berücksichtige, dass die Verfügbarkeit bestimmter Intervalle vom voreingestellten Zeitraum (von... bis) abhängig ist.",
        day: "Tag",
        week: "Woche",
        quarter: "15 Minuten",
        hour: "Stunde",
      },
      table: {
        date: "Datum",
        interval: "Zeit",
        includeUserErrors: "Benutzerbasierte Fehler",
        successRate: "Erfolgsquote",
        failureRate: "Fehlerquote",
        noData: "Keine Daten",
      },
      errors: {
        isin: "ISIN",
        count: "Anzahl Tracking errors",
      },
    },
    cryptoRefresh: {
      title: "Crypto Currencies",
      form: {
        coinGeckoId: "CoinGecko ID",
      },
      addButton: "Add",
      successMessage: "Crypto currency added successfully",
      errorMessage: "Failed to add crypto currency",
      refreshButton: "Refresh",
      refreshSuccessMessage: "Crypto currency refreshed successfully",
      refreshErrorMessage: "Failed to refresh crypto currency",
    },
  },
  redesign: {
    header: {
      actions: {
        fundDiscount: "Fondsdiscount",
        yourDiscount: "Ihre Vorteile",
        depotManagerApp: "Depotverwaltungs-App",
        aboutUs: "Über uns",
        knowledge: "Wissen",
        login: "Login",
        becomeCustomer: "Kunde werden",
        inApp: "Home",
        cashback: "Cashback beantragen",
        faqs: "FAQs",
        forum: "Forum",
        blog: "Blog",
        support: "Support",
      },
    },
    footer: {
      copyright: "Rentablo GmbH",
      column1: {
        title: "Unternehmen",
        items: [
          // {
          //   href: "https://rentablo.de/aboutUs",
          //   title: "Über uns",
          // },
          {
            href: "https://rentablo.de/jobs",
            title: "Jobs & Karriere",
          },
          {
            href: "https://www.financequality.net/partnerprogramme/rentablo-fond-cashback/",
            title: "Partnerprogramm",
          },
          {
            href: "https://rentablo.de/sicherheit",
            title: "Sicherheit",
          },
          {
            href: "https://wealthapi.eu",
            title: "Geschäftskunden",
          },
        ],
      },
      column2: {
        title: "Features",
        items: [
          {
            href: "https://rentablo.de/software-depotverwaltung",
            title: "Software Depotverwaltung",
          },
          {
            href: "https://rentablo.de/portfolio-performance",
            title: "Portfolio Performance",
          },
          {
            href: "https://rentablo.de/portfolio-optimierung",
            title: "Portfolio Optimierung",
          },
          {
            href: "https://rentablo.de/kostenloser-finanzmanager-online",
            title: "Kostenloser Portfoliomanager",
          },
          {
            href: "https://rentablo.de/elektronisches-haushaltsbuch",
            title: "Elektronisches Haushaltsbuch",
          },
        ],
      },
      column3: {
        title: "Wissen & Finanztools",
        items: [
          {
            href: "https://forum.rentablo.de/",
            title: "Forum & FAQ",
          },
          {
            href: "https://blog.rentablo.de/",
            title: "Finanzblog",
          },
          {
            href: "https://rentablo.de#cashback-calculator",
            title: "Fondsdiscount-Rechner",
          },
          {
            href: "https://rentablo.de/investment/popularFunds",
            title: "Beliebte Fonds",
          },
        ],
      },
      column4: {
        title: "Finanztools & Wissen",
        items: [
          {
            href: "https://forum.rentablo.de/",
            title: "Forum & FAQ",
          },
          {
            href: "https://blog.rentablo.de/",
            title: "Finanzblog",
          },
          {
            href: "https://rentablo.de/kostenloser-finanzmanager-online",
            title: "Kostenloser Portfoliomanager",
          },
          {
            href: "https://rentablo.de/elektronisches-haushaltsbuch",
            title: "Elektronisches Haushaltsbuch",
          },
          {
            href: "https://blog.rentablo.de/vergleichsrechner-und-finanztools/",
            title: "Vergleichsrechner",
          },
        ],
      },
      subFooterItems: [
        {
          href: "impressum",
          title: "Impressum",
        },
        {
          href: "privacy",
          title: "Datenschutz",
        },
        {
          href: "agb",
          title: "AGBs",
        },
        {
          href: "disclaimer",
          title: "Haftungsausschluss",
        },
      ],
    },
  },
  addToDepot: "Zum Depot hinzufügen",
  addToWatchlist: "Zur Watchlist hinzufügen",
  showMore: "mehr anzeigen",
  supportCard: {
    caption: "Ich bin für Sie zuständig",
    title: "Patrick Rujan",
    subtitle: "Kundensupport {{appName}}",
  },
  bankSelect: {
    pageTitle: "Depots/Konten importieren",
    title: "Bitte wählen Sie Ihre Bank",
    searchLabel: "Suche: Name, IBAN, BLZ, BIC",
    selectBic: {
      title:
        "Bitte wählen Sie Ihre BIC. <bold>BIC</bold> (Bank Identifier Code) ist eine <bold>8- oder 11-stellige Bankleitzahl</bold>, mit der <bold>Geldinstitute weltweit eindeutig identifiziert</bold> werden können.",
      back: "Zurück",
    },
    notFound: "Nicht gefunden",
    notSupported: "Diese Bank wird aktuell noch nicht unterstützt",
  },
  netfondsOnboarding: {
    next: "Speichern und weiter",
    sidebar: {
      main: "Onboarding",
      preferences: "Anlageziele und Präferenzen",
      sustainability: "Nachhaltigkeit",
      details: "Auswahl und dynamische Simulation Strategie",
      signup: "Registrierung",
      experience: "Kenntnisse & Erfahrungen",
      incomeAssets: "Wirtschaftliche Verhältnisse",
      personal: "Persönliche Angaben",
      agreements: "Vereinbarungen",
      summary: "Zusammenfassung",
    },
    investmentGoal: {
      title: "Welches Anlageziel verfolgen Sie?",
      valueRetention: "Werterhalt auf Kapitalmarktzinsniveau",
      longTermInvestment: "Langfristiger Vermögensaufbau",
      shortTermProfit: "Kurzfristige Gewinnerzielungabsicht",
      additionalIncome:
        "Erzielung von Zusatzerträgen bei Inkaufnahme höherer Risiken",
    },
    investmentHorizon: {
      title: "Wie lange möchten Sie anlegen?",
      shortTerm: "0-3 Jahre",
      midTerm: "3-5 Jahre",
      longTerm: "> 5 Jahre",
    },
    preferredRiskClass: {
      title: "Bitte geben Sie Ihre Risikotoleranz an",
      riskClassB: "Ertrag - Risikoklasse B",
      riskClassB_subtitle:
        "Sie haben nur eine <b>geringe Renditeerwartung</b>. Der Werterhalt des Gesamtportfolios steht für Sie im Vordergrund. Sie möchten daher nur <b>geringe Risiken</b> aufgrund von Marktschwankungen (z. B. Kurs-, Zins- und Währungsschwankungen) und nur geringe Verlustrisiken für das Gesamtportfolio eingehen. <b>Risikotoleranz - 5%</b> nach Kosten.",
      riskClassC: "Ausgewogen - Risikoklasse C",
      riskClassC_subtitle:
        "Sie haben eine <b>moderate Renditeerwartung</b>. Neben Zinserträgen wird auch ein Ertrag aus Kurssteigerungen angestrebt. Dafür nehmen Sie <b>moderate Risiken</b> aufgrund von Marktschwankungen (z. B. Kurs-, Zins- und Währungsschwankungen) und moderate Verlustrisiken für das Gesamtportfolio in Kauf. <b>Risikotoleranz - 30%</b> nach Kosten.",
      riskClassD: "Wachstum - Risikoklasse D",
      riskClassD_subtitle:
        "Sie haben eine <b>höhere Renditeerwartung</b>, die möglichst dauerhaft über dem Kapitalmarktzinsniveau liegt. Dafür nehmen Sie <b>höhere Risiken</b> aufgrund von Marktschwankungen (z. B. Kurs-, Zins- und Währungsschwankungen) und höhere Verlustrisiken für das Gesamtportfolio in Kauf. <b>Risikotoleranz - 50%</b> nach Kosten.",
    },
    sustainabilityPreference: {
      title: "Nachhaltigkeitspräferenzen wählen",
      important: "Ja, nachhaltige Geldanlage ist mir wichtig",
      notImportant: "Nein, nachhaltige Geldanlage ist mir nicht wichtig",
      notSure: "Ich bin noch unentschlossen, aktuell noch nicht",
    },
    sustainabilityFactors: {
      title: "Welche weiteren Nachhaltigkeitsfaktoren sind Ihnen wichtig?",
      subtitle:
        "Hinweis: Sie können die folgenden Konzepte einzeln, aber auch alle gemeinsam berücksichtigen. Je restriktiver Sie vorgehen, desto weniger Geldanlageprodukte werden zur Auswahl stehen. Weitere Informationen finden Sie in der <linkText>Nachhaltigkeitsbroschüre</linkText>.",
      climateProtection:
        "Klimaschutz, Anpassung an den Klimawandel (Taxonomie)",
      climateProtection_tooltipTitle: "EU-Taxonomie",
      climateProtection_tooltipText:
        "Klassifizierungssystem für nachhaltige Wirtschaftstätigkeiten innerhalb der EU mit derzeit 6 Umweltzielen im Fokus. Voraussetzung: Ein Unternehmen muss einen Beitrag zu mindestens einem Umweltziel leisten und kein Verstoß gegen die anderen Umweltziele und Einhaltung der Mindestanforderungen in den Bereichen Governance, Menschen- und Arbeitnehmerrechte. Der Anteil ökologisch nachhaltiger Investitionen i.S.d. Taxonomieverordnung wird in Prozent mit Werten von 0 bis 100 angegeben. Je höher der Wert, desto positiver im Sinne von ökologisch nachhaltig ist er.",
      unSustainableDevelopmentGoals:
        "UN Sustainable Development Goals (Offenlegung)",
      unSustainableDevelopmentGoals_tooltipTitle:
        "UN Sustainable Development Goals (Offenlegung)",
      unSustainableDevelopmentGoals_tooltipText:
        'Bewertung, inwieweit Unternehmen Möglichkeiten zur Erreichung der 17 von der UN definierten Nachhaltigkeitsziele ("Sustainable Development Goals" - SDGs) nutzen. Die Werteskala reicht von -100% (erhebliche Behinderung) bis 100% (wesentlicher Beitrag zur Zielerreichung).',
      exclusionsTitle:
        "Bitte wählen Sie aus, welche absoluten Ausschlüsse Ihnen für die Geldanlage wichtig sind",
      gasEmission: "Treibhausgas-Emission",
      gasEmission_tooltipTitle: "Treibhausgas-Emission",
      gasEmission_tooltipText:
        "Direkte und indirekte Freisetzung von klimaschädlichen Gasen und Engagement im Bereich der fossilenBrennstoffe",
      hazardousWaste: "Gefährliche Abfälle",
      hazardousWaste_tooltipTitle: "Gefährliche Abfälle",
      hazardousWaste_tooltipText:
        "Vom Unternehmen erzeugte gefährliche Abfälle",
      waterPollution: "Verschmutzung von Wasser",
      waterPollution_tooltipTitle: "Verschmutzung von Wasser",
      waterPollution_tooltipText:
        "Ermittlung des chemischen Sauerstoffbedarfs (CSB) zur Bewertung der Belastung von Abwasser mit organischen Stoffen",
      negativeImpact: "Negativer Einfluss auf die Biodiversität",
      negativeImpact_tooltipTitle: "Negativer Einfluss auf die Biodiversität",
      negativeImpact_tooltipText:
        "Aktivitäten mit negativem Einfluss auf biodiversitätssensible Gebiete",
      socialEmployment: "Soziales und Arbeitnehmerbelange",
      socialEmployment_tooltipTitle: "Soziales und Arbeitnehmerbelange",
      socialEmployment_tooltipText:
        "Verstöße gegen die UNGC/OECD-Leitsätze und unbereinigtes geschlechtsspezifisches Lohngefälle",
      sustainabilityClass: {
        title: "Ihre Nachhaltigkeitsklasse",
        text: "Ihre Nachhaltigkeitsklasse beträgt aktuell 1 von 5.",
        link: "weitere Informationen",
      },
    },
    details: {
      title: "Konfigurieren Sie die Details Ihrer Anlage",
      strategy: "Ihre Anlagestrategie",
      chartTitle: "Erwartete Vermögensentwicklung",
      return: "Rendite",
      volatility: "Volatilität",
      "10-years": "10 Jahre",
      "20-years": "20 Jahre",
      investmentAmount: "Ihre erstmalige Anlage",
      savingsPlan: "Ihr monatlicher Sparplan",
    },
    signup: {
      title: "Registrierung",
      email: "Ihre Email Adresse",
      email_placeholder: "Bitte geben Sie Ihre Email Adresse ein...",
      password: "Passwort",
      password_placeholder: "Bitte legen Sie ein Passwort fest...",
      acceptedTerms:
        "Ich willige in die Verarbeitung meiner Daten ein. Diese werden sowohl an Musterfinanz als Vermittler der Vermögensverwaltung, an die Netfonds AG, als Abwickler sowie die jeweilige Depotbank zur Eröffnung des Depots versandt. Nähere Angaben zu der Verwendung Ihrer Daten finden Sie in der <link>Datenschutzerklärung</link>.",
      receiveNewsletter:
        "Ich möchte regelmäßig über neue Angebote <link1>informiert werden</link1>. Ihre hiermit erteilten Einwilligen sind jederzeit widerruflich (per E-Mail an <link2>max.mustermann@musterfinanz.de</link2> oder an die im Impressum angegebenen Kontaktdaten).",
    },
    systemKnowledge: {
      title: "In welchen Anlagen haben Sie Kenntnisse?",
      subtitle: "Mehrfachauswahl möglich",
      shares: "Aktien",
      funds: "Fonds",
      security3: "Wertpapier 3",
      security4: "Wertpapier 4",
      noKnowledge: "Keine Kenntnisse",
    },
    investmentExperience: {
      title: "Wie sind Ihre Erfahrungen mit diesen Anlagen?",
      subtitle: "Anzahl der Geschäfte in den letzten 5 Jahren.",
      shares: "Aktien",
      funds: "Fonds",
      security3: "Wertpapier 3",
      security4: "Wertpapier 4",
      "1-5-years": "1-5 Jahre",
      "more-than-5-years": "> 5 Jahre",
      noExperience: "Keine",
    },
    netIncomePerMonth: {
      title: "Monatliche Nettoeinkünfte",
      netIncomePerMonth: "Wie hoch sind Ihre monatlichen Nettoeinkünfte?",
    },
    expensesPerMonth: {
      title: "Monatliche Ausgaben",
      expensesPerMonth: "Wie hoch sind Ihre monatlichen Ausgaben?",
    },
    assets: {
      title:
        "Besitzen Sie Vermögen in Form von Immobilien oder Beteiligungen? Wenn ja, wie hoch ist dieses Vermögen circa?",
      "more-than-0": "> 0 €",
      "more-than-25000": "> 25.000 €",
      "more-than-50000": "> 50.000 €",
      "more-than-75000": "> 75.000 €",
      "more-than-100000": "> 100.000 €",
      other: "andere Angabe",
      realEstateAssets: "Ihr Vermögen in Immobilien/Beteiligungen",
    },
    personalData: {
      title: "Bitte geben Sie Ihre persönlichen Daten ein",
      subtitle:
        "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
      salutation: "Anrede",
      salutation_placeholder: "Wählen Sie eine Anrede",
      academicTitle: "Akademischer Titel",
      academicTitle_placeholder: "Wählen Sie Ihren Titel",
      firstName: "Vorname",
      firstName_placeholder: "Ihr Vorname",
      lastName: "Nachname",
      lastName_placeholder: "Ihr Nachname",
      dateOfBirth: "Geburtsdatum",
      placeOfBirth: "Geburtsort",
      placeOfBirth_placeholder: "Bitte Geburtsort angeben",
      countryOfBirth: "Geburtsland",
      countryOfBirth_placeholder: "Bitte wählen Sie ihr Geburtsland",
      maritalStatus: "Familienstand",
      maritalStatus_placeholder: "Bitte wählen Sie Ihren Familienstand",
      phoneNumber: "Tel. Mobil",
      phoneNumber_placeholder: "Bitte Ihre Mobilfunknummer ein",
      email: "E-Mail",
      email_placeholder: "Bitte geben Sie Ihre E-Mail Adresse ein",
      education: "Ausbildung",
      education_placeholder: "Bitte wählen Sie Ihre Ausbildung",
      occupation: "Beruf",
      occupation_placeholder: "Bitte wählen Sie Ihren Beruf",
      sector: "Branche",
      sector_placeholder: "Bitte wählen Sie eine Branche",
    },
    addressData: {
      title: "Bitte geben Sie Ihre Adresse ein",
      subtitle:
        "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
      street: "Straße",
      houseNumber: "Hausnummer",
      houseNumber_placeholder: "Nr.",
      zip: "Postleitzahl",
      city: "Wohnort",
      city_placeholder: "Ihr Wohnort",
      addressCountry: "Land",
      nationalityCountry: "Staatsangehörigkeit",
    },
    taxationData: {
      title: "Ihre steuerrelevanten Daten",
      taxationCountry1: "Steuerpflichtig in ",
      taxationNumber1: "Steueridentifikationsnummer",
      interText: "Haben Sie eine weitere Steueransässigkeit?",
      taxationCountry2: "Steuerpflichtig in ",
      taxationNumber2: "Steueridentifikationsnummer",
    },
    mifidData: {
      title: "Bitte geben Sie Ihre Daten für MiFID ein",
      isNotPoliticallyExposed: "Ich bin keine politisch exponierte Person",
      isNotPoliticallyExposed_tooltipTitle: "Politisch exponierte Person",
      isNotPoliticallyExposed_tooltipText:
        "(PEP) sind gemäß §6 Abs. 2 Nr. 1 Geldwäschegesetz Personen, die ein wichtiges öffentliches Amt ausüben oder ausgeübt haben (z.B. Politiker, Botschafter).\n" +
        "Nehmen Sie bei Fragen gerne persönlichen Kontakt mit uns oder Ihrer Beraterin/Ihrem Berater auf.",
      isOwnAccount: "Ich handele auf eigene Rechnung",
      isOwnAccount_tooltipTitle: "Wirtschaftlich Berechtigte(r)",
      isOwnAccount_tooltipText:
        "Sollten Sie nicht auf eigene Rechnung handeln, wenden Sie sich bitte persönlich an uns oder Ihre Beraterin/Ihren Berater - wir helfen Ihnen bei der Anlage.\n" +
        "Aus technischen Gründen ist ein Online-Strategiekauf momentan nur für wirtschaftlich berechtigte Personen möglich.",
    },
    contraAccount: {
      title: "Bankverbindung",
      banner: {
        text: "Ein Referenzkonto ist ein Girokonto bei Ihrer Bank, das zur Abwicklung  des Zahlungsverkehrs dient. Ihr Referenzkonto muss SEPA-fähig sein und in Euro geführt werden.",
      },
      iban: "IBAN",
      formSectionLabel: "Kontoinhaber des Referenzkontos",
      contraAccountHolderFirstName: "Vorname",
      contraAccountHolderFirstName_placeholder: "Vorname des Kontoinhabers",
      contraAccountHolderLastName: "Nachname",
      contraAccountHolderLastName_placeholder: "Nachname des Kontoinhabers",
    },
    agreements: {
      title: "Vereinbarungen",
      subtitle:
        "Bitte lesen Sie sich die nachfolgenden Vereinbarungen in Ruhe durch:",
      customerInfoAcknowlegmentAccepted:
        "Ich habe die <linkText>Kundeninformationen</linkText> erhalten und zur Kenntnis genommen.",
      frameworkAgreementAccepted:
        "Ich stimme der <linkText>Rahmenvereinbarung</linkText> zu",
      processingDataAccepted:
        "Ich willige in die Verarbeitung meiner Daten ein. Diese werden sowohl an wealthAPI / Wolfram  Stacklies, als Zuführer zur NFS Hamburger Vermögen GmbH, an die Netfonds AG,, als Abwickler sowie an die jeweilige Deoptbank (FIL Fondsbank GmbH) zur Eröffnung des Depots und Anlagen in die gewählten Strategien versand. Nährere Angaben zu der Verwendung Ihrer Daten finden Sie in den <linkText>Datenschutzhinweisen</linkText>.",
      servicesPerfomanceAccepted:
        "Hiermit erkläre ich mich in der Ausführung der beauftragten Dienstleistungen vor Ablauf der Widerrufsfrist von 14 Tagen nach Abgabe meiner Vertragserklärung einverstanden.",
    },
    consent: {
      title: "Einwilligung zur Kontaktaufnahme (Modul A + B)",
      subtitle:
        "Aus Gründen der besseren Lesbarkeit wird die gleichzeitige Verwendung der Sprachformen männlich, weiblich und divers verzichtet. Sämtliche Personenbezeichnungen gelten gleichermaßen für alle Geschlechter. der Kunde willigt in die Kontaktaufnahme mit folgenden Kommunikationsmitteln ein:",
      sections: {
        1: "Modul A",
        2: "Modul B",
        3: "Modul C",
      },
      contactViaPhone:
        "per Telefon oder ggf. SMS (bei Angabe einer Mobilfunknummer",
      contactViaEmail: "per E-Mail",
      contactViaFax: "per Telefax",
      contactViaMessengers:
        "per Messangerdienst (Whatsapp, Signal u.a.) und oder Internettelefonie",
      contactViaElectronicCommunication:
        "per elektronischem Postfach unter Einsatz verschiedener Authentifizierungsverfahren",
      newsletterAccepted:
        "Ich willige ein, Marktinformationen, Newsletter und Informationen zu Produkten und Dienstleistungen über Fernkommunikationsmittel  zu erhalten.",
      newsletterNotAccepted: "Ich willige nicht ein",
      banner: {
        text: "Hinweis: Die Einwilligungserklärungen sind freiwillig und können ohne Einfluss auf bestehende Vertragsverhältnisse ganz oder teilweise (auch für einzelne Kommunikationswege und Module) widerrufen werden. Für die einzelnen Module A,B,C gelten die unten stehenden Bedingungen. ",
      },
      warning:
        "Bitte beachten Sie, dass eine Kombination der einzelnen Module möglich ist. ",
    },
    summary: {
      title: "Zusammenfassung",
      personalDataTitle: "Persönliche Daten",
      depotManagement: "Depotführung",
      assetManagement: "Bevollmächtigter Vermögensverwalter",
      portfolioPurchase: "Kauf im Portfolio",
      savingsPlan: "Monatlicher Sparplan",
      managementFee: "Laufende Verwaltungsvergütung",
      riskClass: "Risikoklasse",
      documents: "Dokumente",
      apply: "Kostenpflichtig beantragen",
      riskClassB: "B",
      riskClassC: "C",
      riskClassD: "D",
      fields: {
        academicTitle: "Titel",
        education: "Ausbildung",
        salutation: "Anrede",
        occupation: "Beruf",
        fullName: "Vor- und Nachname",
        sector: "Branche",
        dateOfBirth: "Geburtsdatum",
        placeOfBirth: "Geburtsort",
        address: "Wohnhaft in",
        taxationNumber1: "Steuernummer (TIN)",
        taxationCountry1: "Steuerpflichtig in",
        nationalityCountry: "Staatsangehörigkeit",
        phoneNumber: "Mobilfunknummer",
        email: "E-Mail",
        accountHolderName: "Kontoinhaber",
        maritalStatus: "Familienstand",
        iban: "IBAN",
        isNotPoliticallyExposed: "keine politisch exponierte Person",
        isOwnAccount: "Wirtschaftlich Begünstigter",
      },
    },
  },
  finanzfluss: {
    bankConnections: {
      bankingCredentials: {
        storeSecrets: {
          info: "Deine Daten werden sicher verschlüsselt gespeichert. Nur wenn der Haken gesetzt ist, kann dein Konto automatisch aktualisiert werden.",
        },
      },
      bankIsBusy: {
        bannerText:
          "Aktuell werden sehr viele parallele Import Anfragen an {{bankName}} gestellt. Dadurch kann es zu einer temporären Unterbrechung der Verbindung durch den Broker kommen. Wir bitten um dein Verständnis, dass der Import Ihres {{bankName}} Depots aktuell nicht möglich ist. Versuche es gerne erneut in einigen Minuten.",
      },
    },
  },
  feedbackPage: {
    title: "Euer Feedback hilft uns, die richtigen Dinge zu priorisieren.",
    intro:
      "Dein Feedback ist für uns von unschätzbarem Wert ❤️️ und wir arbeiten kontinuierlich daran, den Copilot zu verbessern und deine Erfahrung damit so positiv wie möglich zu gestalten. <br /> <br /> Auf dieser Seite kannst du sehen, an welchen Verbesserungen wir aktuell arbeiten. Außerdem kannst du uns deine eigenen Verbesserungsvorschläge mitteilen und über die Vorschläge anderer Nutzer abstimmen. So hilfst du uns, die richtigen Dinge zu priorisieren.<br /> <br /> Fragen zur Benutzung des Copilot hat oder technische Probleme kannst du über 👉 <linkText>folgendes Formular</linkText> 👈 an uns schicken. Vielen Dank für deine Unterstützung 🙏",
    link: "folgendes Formular",
  },
  securitiesSearch: {
    title: "Asset suchen",
    placeholder: "Name, ISIN oder WKN eingeben",
    all: "Alle",
    back: "Zurück zu Suchergebnissen",
    isin: "ISIN",
    type: "Klasse",
    showMore: "Mehr anzeigen",
    loading: "Lade...",
    noResults: "Keine Ergebnisse",
  },
};
